// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep #holder > li {
  padding: 5px;
  margin: 2px;
  display: inline-block;
  border-color: #ddd;
}

::ng-deep #holder > li[data-page] {
  border: solid #a0a0a0 1px;
  border-radius: 5px;
}

::ng-deep #holder > li.separator:before {
  content: "...";
}

::ng-deep #holder > li.active {
  background-color: #f4f4f4;
  color: inherit;
}

::ng-deep #holder > li[data-page]:hover {
  cursor: pointer;
}

.groups {
  margin-left: 15px;
  margin-bottom: 10px;
}

.reset-input th {
  position: relative;
}
.reset-input th input[type=search] {
  width: 100% !important;
}
.reset-input th .reset-close {
  display: none;
  position: absolute;
  top: 0;
  right: 25px;
  bottom: 0;
  margin: auto;
  border-radius: 50%;
  background: #ddd;
  border: none !important;
  text-align: center;
  font-size: 14px;
  padding: 0px !important;
  height: 16px !important;
  width: 16px !important;
  color: #fff;
  line-height: 1.2 !important;
  font-family: Arial !important;
  transform: rotate(45deg) !important;
  -webkit-transform: rotate(45deg) !important;
}
.reset-input th:hover .reset-close {
  display: block;
}

.tva__head {
  min-height: 84px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  margin-inline: 15px;
  padding: 17px 35px;
}
.tva__head i:hover {
  color: rgb(105, 190, 40);
}
@media only screen and (max-width: 767px) {
  .tva__head {
    padding-inline: 20px;
  }
}
.tva__head--border-0 {
  border: 0;
}
.tva__head--type-1 {
  padding: 8px 27px;
  min-height: auto;
}
@media only screen and (max-width: 767px) {
  .tva__head--type-1 {
    padding-inline: 20px;
  }
}
.tva__head--type-1 .tva__cta__hd h5 {
  font-size: 16px;
  font-weight: 700;
}
.tva__head--brb-0 {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.tva__head .f-m-bottom-0 + span {
  font-weight: bold;
  font-size: 12px;
}
.tva__head .f-m-bottom-0 + span img {
  width: 40px;
  margin-left: 6px;
}
.tva__cta__hd {
  width: 100%;
}
.tva__cta__hd h5 {
  font-size: 24px;
  font-weight: 700;
  color: #676a6c;
  margin-top: 0;
}
.tva__cta__hd h5.tva__head_subtitle {
  font-size: 16px;
}
.tva__cta__hd small {
  font-size: 14px;
}
.tva__cta__btn {
  display: inline-block;
}
.tva__cta__btn--comp a {
  background-color: transparent;
  padding: 0;
  color: #676a6c;
  border-color: #e7eaec;
}
.tva__cta__btn--comp a span {
  display: inline-block;
  padding: 5px 12px;
}
.tva__cta__btn--comp a span:first-child {
  border-right: 1px solid #e7eaec;
}
.tva__bot table {
  border: 1px solid #e7eaec;
  border-collapse: collapse;
}
.tva__bot table thead tr:first-child {
  background-color: #f1f1f2;
}
.tva__bot table thead tr input[type=checkbox] {
  border: 1px solid #e7eaec;
}
.tva__bot table thead tr th {
  border: 0;
}
.tva__bot table input[type=checkbox] {
  display: none;
}
.tva__bot table input[type=checkbox] + label {
  position: relative;
  cursor: pointer;
}
.tva__bot table input[type=checkbox] + label::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 10px;
  width: 10px;
  border: 1px solid #e7eaec;
  border-radius: 3px;
}
.tva__bot table input[type=checkbox]:checked + label::after {
  content: "";
  position: absolute;
  left: 4px;
  top: 3px;
  border-right: 2px solid #e7eaec;
  border-bottom: 2px solid #e7eaec;
  rotate: 45deg;
  height: 4px;
  width: 2px;
}

.back {
  background-color: #fff;
  color: #676a6c;
  border: 0;
}

._mb_5 {
  margin-bottom: 5px;
}

._bg_neutral_light {
  background-color: #f1f1f2;
}

._color_body_content {
  color: #676a6c;
}

.lead, .teams .title-case.role span, .teams__profile span.lead {
  font-size: 8px;
  font-weight: 700;
  display: inline-block;
  padding: 2px 4px;
  background-color: #676a6c;
  border-radius: 2px;
  color: #fff;
}
.lead--round {
  background-color: #fff !important;
  color: #676a6c !important;
  border-radius: 50% !important;
  border: 1px solid #e7eaec !important;
}

::ng-deep.userProfile {
  border: 2px solid #f1f1f2;
  border-radius: 4px;
  border-top: 0;
}
::ng-deep.userProfile--brt-0 {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
::ng-deep.userProfile--bdr-0 {
  border: 0;
}
@media only screen and (max-width: 1199px) {
  ::ng-deep.userProfile__top-row > div {
    width: 100%;
  }
}
::ng-deep.userProfile__team {
  padding-inline: 8px;
}
::ng-deep.userProfile__team__accord {
  border: 1px solid #e7eaec;
  border-radius: 4px;
  border-top: 0;
  min-height: 100%;
}
::ng-deep.userProfile__team__accord--zindex {
  position: relative;
  z-index: 999;
}
::ng-deep.userProfile__team__accord--mr {
  margin-right: 2%;
}
::ng-deep.userProfile__team__accord_header {
  background-color: #f1f1f2;
  padding: 10px 19px;
  min-height: 38px;
  display: flex;
  align-items: center;
}
::ng-deep.userProfile__team__accord_header--posZind {
  position: relative;
  z-index: 999;
}
::ng-deep.userProfile__team__accord_header h5 {
  color: #676a6c;
  margin-top: 0;
  font-size: 14px;
}
::ng-deep.userProfile__team__accord_body {
  padding: 13px 18px;
  position: relative;
}
::ng-deep.userProfile__team__accord_body > :not(:last-child), ::ng-deep.userProfile__team__accord_body_list > :not(:last-child) {
  margin-bottom: 15px;
}
::ng-deep.userProfile__team__accord_body_list:not(:last-child) {
  margin-bottom: 7px !important;
}
::ng-deep.userProfile__team__accord_body_list {
  max-height: 146px;
  overflow: hidden;
  transition: all ease 0.5s;
}
::ng-deep.userProfile__team__accord_body_list.active {
  max-height: none;
}
::ng-deep.userProfile__team__accord_body * {
  margin-top: 0;
}
::ng-deep.userProfile__team__accord_body a {
  color: #676a6c;
}
::ng-deep.userProfile__team__accord_body ul,
::ng-deep.userProfile__team__accord_body ol {
  margin: 0 0 0 14px;
  padding: 0;
}
::ng-deep.userProfile__team__accord_body ul > :not(:last-child),
::ng-deep.userProfile__team__accord_body ol > :not(:last-child) {
  margin-bottom: 10px;
}
::ng-deep.userProfile__team__accord_body h5 {
  font-weight: 700;
  font-size: 14px;
}
::ng-deep.userProfile__team__accord_body p,
::ng-deep.userProfile__team__accord_body li {
  font-weight: 600;
  font-size: 12px;
}
::ng-deep.userProfile__team__accord_body .active + .userProfile__team__accord_body_show_more_button {
  position: static;
  background-color: transparent;
  padding-top: 0;
}
::ng-deep.userProfile__team__accord_body_show_more_button {
  text-align: center;
  position: absolute;
  bottom: 10px;
  right: 0;
  left: 0;
  background: linear-gradient(180deg, transparent, #fff);
  padding-top: 10px;
}
::ng-deep.userProfile__team__accord_body_exter_links > :not(:last-child) {
  border-bottom: 1px solid #e7eaec;
  margin-bottom: 4px;
  padding-bottom: 7px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.userProfile__team__accord_body_exter_links > div > div {
    flex: none;
    width: 100%;
    text-align: left;
  }
}
::ng-deep.userProfile__team__accord_body_exter_links a:hover i {
  color: rgb(105, 190, 40);
}
::ng-deep.userProfile__team__accord_body_exter_links a i {
  transition: 300ms;
}
::ng-deep.userProfile__team__accord_body_groups {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 20px;
}
@media only screen and (max-width: 1199px) {
  ::ng-deep.userProfile__team__accord_body_groups {
    grid-template-columns: repeat(2, 1fr);
  }
}
::ng-deep.userProfile__team__accord_body_groups .clarify .userProfile__team__accord_body_groups_header {
  background-color: rgb(0, 173, 208);
}
::ng-deep.userProfile__team__accord_body_groups .clarify h5 {
  color: #676a6c;
  font-weight: 600;
}
::ng-deep.userProfile__team__accord_body_groups .clarify h5 span {
  color: rgb(0, 173, 208);
}
::ng-deep.userProfile__team__accord_body_groups .ideate .userProfile__team__accord_body_groups_header {
  background-color: rgb(255, 121, 0);
}
::ng-deep.userProfile__team__accord_body_groups .ideate h5 {
  color: #676a6c;
  font-weight: 600;
}
::ng-deep.userProfile__team__accord_body_groups .ideate h5 span {
  color: rgb(255, 121, 0);
}
::ng-deep.userProfile__team__accord_body_groups .develop .userProfile__team__accord_body_groups_header {
  background-color: rgb(105, 190, 40);
}
::ng-deep.userProfile__team__accord_body_groups .develop h5 {
  color: #676a6c;
  font-weight: 600;
}
::ng-deep.userProfile__team__accord_body_groups .develop h5 span {
  color: rgb(105, 190, 40);
}
::ng-deep.userProfile__team__accord_body_groups .implement .userProfile__team__accord_body_groups_header {
  background-color: rgb(245, 67, 89);
}
::ng-deep.userProfile__team__accord_body_groups .implement h5 {
  color: #676a6c;
  font-weight: 600;
}
::ng-deep.userProfile__team__accord_body_groups .implement h5 span {
  color: rgb(245, 67, 89);
}
::ng-deep.userProfile__team__accord_body_groups_header {
  padding: 6px 10px;
  border-radius: 2px;
  background-color: var(--group_clr);
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}
::ng-deep.userProfile__team__accord_body_groups_header:not(:last-child) {
  margin-bottom: 15px;
}
::ng-deep.userProfile__team__accord_body_groups h5 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 3px;
}
::ng-deep.userProfile__team__accord_body_groups h5:not(:last-child) {
  margin-bottom: 5px;
}
::ng-deep.userProfile__team__accord_body_groups h5 span {
  width: 18px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #f1f1f2;
  font-size: 0.8em;
}
::ng-deep.userProfile__team__accord_body_groups ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
::ng-deep.userProfile__team__accord_body_groups ul:not(:last-child) {
  margin-bottom: 15px;
}
::ng-deep.userProfile__team__accord_body_groups ul li:not(:last-child) {
  margin-bottom: 3px;
}
::ng-deep.userProfile__team__spcltxt {
  font-size: 12px;
  padding: 10px 16px;
  font-style: italic;
}
::ng-deep.userProfile__graph .wrapper-content--pd-0 {
  padding: 0;
}
::ng-deep.userProfile__graph_header {
  background-color: #f1f1f2;
  padding: 9px 17px;
  font-size: 14px;
  font-weight: 700;
  color: #676a6c;
  border-radius: 5px 5px 0 0;
}
::ng-deep.userProfile__graph_header span {
  font-weight: 600;
}
::ng-deep.userProfile__graph_header span .tooltip-text {
  display: none;
}
::ng-deep.userProfile__graph_header span.info-text {
  position: relative;
}
::ng-deep.userProfile__graph_header span.info-text:hover {
  cursor: pointer;
}
::ng-deep.userProfile__graph_header span.info-text:hover .tooltip-text {
  display: none;
  position: absolute;
  display: inline-block;
  min-width: 240px;
  bottom: calc(100% + 10px);
  background-color: #fff;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px;
  border-radius: 4px;
  text-align: center;
  z-index: 99;
}
::ng-deep.userProfile__graph_header span.info-text:hover .tooltip-text::before {
  content: "";
  width: 16px;
  height: 8px;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  background-color: #fff;
  position: absolute;
  top: 99%;
  left: 50%;
  transform: translateX(-50%);
}
::ng-deep.userProfile__graph__plan {
  width: 85%;
  margin-left: auto;
}
::ng-deep.userProfile__graph__plan h5 {
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #e7eaec;
  padding-bottom: 10px;
  margin: 0;
}
::ng-deep.userProfile__graph__plan-pf {
  color: #676a6c;
  opacity: 0.6;
}
::ng-deep.userProfile__graph__plan-pf .teams__profile_inner {
  padding-inline: 5px;
  border-right: 1px solid #e7eaec;
}
::ng-deep.userProfile__graph__plan-pf .teams__profile_inner:last-child {
  border-right: 0;
}
::ng-deep.userProfile__graph__plan-pf .teams__profile_inner .nobg {
  background-color: transparent !important;
  font-weight: 400 !important;
}
::ng-deep.userProfile__graph__plan--our {
  position: relative;
  z-index: 999;
}
::ng-deep.userProfile__graph__plan--our h5 {
  padding-bottom: 0;
  border: 0;
}
::ng-deep.userProfile__graph__plan--our textarea {
  border: 1px solid #e7eaec;
}
::ng-deep.userProfile__graph__plan--our .cross_icn {
  width: 22px;
  height: 22px;
  border: 1px solid #e7eaec;
  position: relative;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
::ng-deep.userProfile__graph__plan--our .cancel_btn {
  color: #676a6c;
  border: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  transition: all ease 0.3s;
  padding-right: 7px;
}
::ng-deep.userProfile__graph__plan--our .save_btn {
  display: inline-block;
  font-size: 10px;
  font-weight: bold;
  border: 1px solid #e7eaec;
  border-radius: 20px;
  padding: 3px 6px;
}
::ng-deep.userProfile__graph__lead {
  width: 87%;
  margin-left: auto;
}
::ng-deep.userProfile .team-compo {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  grid-gap: 30px;
}
::ng-deep.userProfile .team-compo .profile-section {
  margin-bottom: 0;
  flex: 1.2;
}
::ng-deep.userProfile .team-compo .below-chart {
  flex: 1;
  box-shadow: none;
  border-radius: 4px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.userProfile .team-compo .below-chart {
    flex: auto;
  }
}
::ng-deep.userProfile .team-graph .chart-container {
  max-width: 100% !important;
}

.teams_cont--mxwd {
  max-width: 357px;
}
.teams__row-autofit {
  display: grid;
  margin: 0;
  grid-template-columns: repeat(auto-fit, minmax(0, 230px));
  grid-gap: calc(2 * var(--gap-default));
}
@media only screen and (max-width: 767px) {
  .teams__row-autofit {
    grid-template-columns: 1fr;
  }
}
.teams__col-autofit {
  width: 100% !important;
  padding-inline: 0;
}
.teams--b-e {
  border: 2px solid #f1f1f2;
  border-radius: 4px;
}
.teams--brt-0 {
  border-top-right-radius: 0;
  border-top-left-radius: 0;
}
@media only screen and (max-width: 1600px) {
  .teams__col-4 {
    width: 50%;
  }
}
@media only screen and (max-width: 1199px) {
  .teams__col-4 {
    width: 100%;
  }
}
@media only screen and (max-width: 1199px) {
  .teams__col-6 {
    width: 100%;
  }
}
.teams__cell {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
@media only screen and (max-width: 767px) {
  .teams__cell {
    margin-right: 0;
  }
}
.teams__cell:hover .teams__header_btn {
  opacity: 1;
  background-color: rgb(105, 190, 40);
}
.teams__header {
  background-color: #f1f1f2;
  padding: 9px 15px 9px 18px;
  border-radius: 5px 5px 0 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 10px;
}
.teams__header--wbg {
  background-color: #fff;
}
.teams__header--bdr {
  border: 1px solid #e7eaec;
}
.teams__header_title {
  font-size: 12px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  font-weight: 700;
  flex: 1;
}
.teams__header_title--capsbrk {
  text-transform: capitalize;
  word-break: break-all;
}
.teams__header_title .tm_name:hover .short_name {
  display: none;
}
.teams__header_title .tm_name:hover .full_name {
  display: inline-block;
}
.teams__header_title .tm_name .full_name {
  display: none;
}
.teams__header_title__contr {
  gap: 10px;
}
.teams__header_title__contr .roster {
  color: #fff;
  background-color: #676a6c;
  border: 1px solid #d9d9d9;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  font-size: 10px;
  padding-top: 1px;
}
.teams__header_title__contr .roster__name {
  display: none;
  width: 150px;
  color: #676a6c;
  background-color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 6px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: -35px;
  left: -16px;
  z-index: 1;
}
.teams__header_title__contr .roster:hover .roster__name {
  display: block;
}
.teams__header_btn {
  background-color: #d9d9d9;
  color: #fff;
  font-weight: 700;
  opacity: 0.6;
  font-size: 10px;
}
.teams__header button {
  background-color: #fff;
  border-radius: 2px;
  padding: 4px 9px;
  font-size: 8px;
  font-weight: 700;
  color: #676a6c;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 4px 9px;
}
.teams__header .disable {
  opacity: 0.5;
  cursor: not-allowed;
}
.teams__profile {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 10px 20px;
  padding: 13px 19px 10px;
}
.teams__profile--pd {
  padding-top: 20px;
  padding-bottom: 0;
  min-height: 46px;
}
.teams__profile--bdrtop {
  border-top: 1px solid #e7eaec;
}
.teams__profile--nflx {
  display: block;
  padding: 13px 9px 10px;
}
.teams__profile_inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 10px;
}
.teams__profile_inner__pfn {
  line-height: 1;
}
.teams__profile_inner .nobg {
  background-color: #fff;
  font-weight: normal;
  padding: 0;
  display: inline-block;
}
.teams__profile_inner--rytbdr {
  border-right: 1px solid #e7eaec;
}
.teams__profile_inner--rytbdr:last-child {
  border-right: 0;
}
.teams__profile_inner ::ng-deep .profile_types {
  margin-left: 0;
}
.teams__profile_inner--gap5 {
  grid-gap: 5px;
}
.teams__profile_inner--gap5 .trans_scale {
  transform: scale(0.8);
}
.teams__profile_inner span {
  display: inline-block;
  background-color: #d4d4d4;
  color: #676a6c;
  padding: 4px;
  font-size: 10px;
  border-radius: 2px;
  font-weight: 700;
  text-align: center;
}
.teams__profile_inner span.txt {
  background-color: transparent;
  display: block;
  padding: 0;
  text-align: left;
  font-weight: 400;
}
@media only screen and (max-width: 991px) {
  .teams__profile_inner {
    width: 100%;
  }
}
.teams__profile_inner--usrPf {
  width: 90%;
  margin-left: auto;
  padding-top: 11px;
}
.teams__profile img {
  margin-right: 5px;
  width: 35px;
}
.teams__profile_name {
  color: #676a6c;
  font-size: 12px;
  font-weight: 700;
}
@media only screen and (max-width: 991px) {
  .teams__profile span.lead, .teams__profile .teams .title-case.role span, .teams .title-case.role .teams__profile span {
    margin-left: auto;
  }
}
.teams__tab_table {
  padding: 20px;
}
.teams__tab_table ::ng-deep table {
  padding: 0;
  border: 1px solid #e7eaec;
  border-collapse: collapse;
  min-width: 450px;
}
.teams__tab_table ::ng-deep table th,
.teams__tab_table ::ng-deep table td {
  border: 1px solid #e7eaec !important;
  padding: 5px;
  font-size: 12px;
}
.teams__tab_table ::ng-deep table th:not(:first-child),
.teams__tab_table ::ng-deep table td:not(:first-child) {
  text-align: center;
}
.teams__tab_table ::ng-deep table td {
  font-weight: 600;
}
.teams__tab_table ::ng-deep table .records_select {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 5px;
  margin-bottom: 0;
}
.teams__tab_table ::ng-deep table .records_select label {
  margin-bottom: 0;
}
.teams__tab_table ::ng-deep table select {
  width: min(70px, 100%);
}
.teams__tab_table ::ng-deep table select:focus {
  outline: none;
}
.teams__tab_content {
  padding: 20px;
}
.teams__tab_content ::ng-deep .team-tls {
  padding: 0;
}
.teams__tab_content ::ng-deep .team-tls__inner {
  padding-inline: 0;
}
.teams__tab_content ::ng-deep .team-tls__inner:not(:last-child) {
  margin-bottom: 10px;
}
.teams__tab_content ::ng-deep .team-tls__inner * {
  font-size: 12px;
  font-weight: 600;
}
.teams__tab_content ::ng-deep .team-tls ul {
  margin: 0;
  padding: 0 0 0 24px;
}
.teams__tab_content ::ng-deep .team-tls ul li:not(:last-child) {
  margin-bottom: 5px;
}
::ng-deep .teams__buttons {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #e7eaec;
  border-bottom: 1px solid #e7eaec;
}
::ng-deep .teams__buttons button {
  flex: 1;
  border: 0;
  color: #676a6c;
  text-align: center;
  font-size: 10px;
  font-weight: 600;
  padding: 12px;
  background-color: transparent;
  cursor: pointer;
  position: relative;
}
::ng-deep .teams__buttons button:hover {
  background-color: #e7eaec;
}
::ng-deep .teams__buttons button.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  height: 2px;
  background-color: rgb(105, 190, 40);
  opacity: 1;
}
::ng-deep .teams__buttons button:not(:last-child) {
  border-right: 1px solid #e7eaec;
}
.teams .profile_types.no-profile {
  background-image: none !important;
  width: auto;
}
.teams .profile_types.no-profile::after {
  color: #676a6c;
  background-color: #d9d9d9;
  content: "No profile";
  padding: 5px 8px;
  font-size: 10px;
  left: -10px;
  position: relative;
  top: -6px;
}
.teams ::ng-deep .team-graph--wd {
  width: 80%;
}
.teams ::ng-deep .team-graph--ma {
  margin: 0 auto;
}
.teams ::ng-deep .team-graph--mva {
  margin: auto 0;
}
.teams ::ng-deep .team-graph.wrapper-content {
  padding: 16px 16px 0;
  margin-bottom: 11px;
}
.teams__plan {
  z-index: 99;
  border-top: 1px solid #e7eaec;
}
.teams__plan h5 {
  font-size: 14px;
  font-weight: 600;
}
.teams__plan p {
  font-size: 12px;
  opacity: 0.6;
}
.teams__plan textarea {
  border: 1px solid #e7eaec;
  width: 100%;
  padding: 10px;
  resize: vertical;
  font-size: 10px;
}
.teams__plan textarea:focus {
  outline: none;
}
.teams__plan--wd {
  max-width: 85%;
  margin-left: auto;
}
.teams__plan--pdt {
  padding-top: 36px;
}
.teams__plan--bdr {
  border: 1px solid #e7eaec;
  border-top: 0;
  padding-inline: 10px;
}
.teams__plan__my:not(:last-child) {
  padding-bottom: 12px;
}
.teams__plan__my i {
  font-size: 10px !important;
}
.teams__plan__my h5 {
  margin: 0;
  font-size: 10px;
}
.teams__plan__my .save_btn {
  display: inline-block;
  font-size: 10px;
  font-weight: bold;
  border: 1px solid #e7eaec;
  border-radius: 20px;
  padding: 3px 6px;
}
.teams__plan__my .cross_icn {
  width: 22px;
  height: 22px;
  border: 1px solid #e7eaec;
  position: relative;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.teams__plan__my .cancel_btn {
  color: #676a6c;
  border: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  transition: all ease 0.3s;
  padding-right: 7px;
}
.teams__plan__my--bdr {
  border-bottom: 1px solid #e7eaec;
}
.teams__plan__my--indiv h5,
.teams__plan__my--indiv i {
  font-size: 14px !important;
}
.teams__plan__my--indiv textarea {
  font-size: 12px;
}
.teams__plan__our {
  padding-bottom: 10px;
}
.teams__plan__svd {
  border: 1px solid #e7eaec;
  padding: 10px 5px;
  border-radius: 5px;
}
.teams__body {
  border: 1px solid #e7eaec;
  border-top: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.teams__body--nobdr {
  border: 0;
}
.teams .team-table {
  padding: 10px;
}
.teams .team-table-bg ::ng-deep .hide-ratio h5 {
  display: none;
}
.teams .team-table-bg ::ng-deep .show-counter {
  display: flex;
  justify-content: center;
}
.teams .team-table-bg ::ng-deep .show-counter.high-clarify h5, .teams .team-table-bg ::ng-deep .show-counter.low-clarify h5 {
  border: 5px solid rgb(0, 173, 208);
  background-color: rgb(0, 173, 208);
  color: rgb(0, 173, 208) !important;
  text-shadow: none !important;
}
.teams .team-table-bg ::ng-deep .show-counter.high-ideate h5, .teams .team-table-bg ::ng-deep .show-counter.low-ideate h5 {
  border: 5px solid rgb(255, 121, 0);
  background-color: rgb(255, 121, 0);
  color: rgb(255, 121, 0) !important;
  text-shadow: none !important;
}
.teams .team-table-bg ::ng-deep .show-counter.high-develop h5, .teams .team-table-bg ::ng-deep .show-counter.low-develop h5 {
  border: 5px solid rgb(105, 190, 40);
  background-color: rgb(105, 190, 40);
  color: rgb(105, 190, 40) !important;
  text-shadow: none !important;
}
.teams .team-table-bg ::ng-deep .show-counter.high-implement h5, .teams .team-table-bg ::ng-deep .show-counter.low-implement h5 {
  border: 5px solid rgb(245, 67, 89);
  background-color: rgb(245, 67, 89);
  color: rgb(245, 67, 89) !important;
  text-shadow: none !important;
}
.teams .team-table-bg ::ng-deep .show-counter h5 {
  height: 30px !important;
  width: 30px !important;
  border-radius: 50%;
  margin-inline: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px !important;
}
@media screen and (max-width: 480px) {
  .teams .team-table-bg ::ng-deep .show-counter h5 {
    height: 20px !important;
    width: 20px !important;
  }
}
.teams .team-table-bg ::ng-deep .high-clarify.common-high.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .high-ideate.common-high.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .high-develop.common-high.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .high-implement.common-high.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .low-clarify.common-low.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .low-ideate.common-low.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .low-develop.common-low.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table-bg ::ng-deep .low-implement.common-low.common-profile._bg_changer {
  background-color: #d9d9d9 !important;
}
.teams .team-table img {
  width: 17%;
}
.teams .team-table table {
  border: 2px solid #f1f1f2;
  border-right: 0;
}
.teams .team-table table thead {
  background-color: #e7eaec;
  padding: 7px;
  font-size: 12px;
}
.teams .team-table table tbody tr td {
  width: 33.3333333333%;
  border-right: 2px solid #f1f1f2;
  padding: 7px;
}
.teams ::ng-deep.ibox {
  border: 0;
}
.teams ::ng-deep.ibox-title {
  border-top: 0;
  padding: 8px 18px;
  min-height: auto;
  background-color: #f1f1f2;
  border-radius: 4px 4px 0 0;
}
.teams ::ng-deep.ibox-title h5 {
  float: none;
  font-size: 12px;
  font-weight: 700;
}
.teams ::ng-deep.ibox-title h5:last-child {
  margin-bottom: 0;
}
.teams ::ng-deep.ibox-title--fx h5 {
  display: flex;
}
.teams ::ng-deep.ibox-content {
  padding: 0;
  border: 1px solid #e7eaec;
  border-radius: 0 0 4px 4px;
}
.teams ::ng-deep.ibox-content table {
  margin-bottom: 0;
}
.teams ::ng-deep.ibox-content table th {
  font-size: 10px;
  color: #676a6c;
}
.teams ::ng-deep.ibox-content table th .soryby_outer {
  display: inline-flex;
  flex-direction: column;
  height: 12px;
  line-height: 1;
  position: relative;
  width: 10px;
  top: 2px;
}
.teams ::ng-deep.ibox-content table th .soryby_outer > div {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.teams ::ng-deep.ibox-content table th .soryby_outer > div:nth-child(1) {
  top: 0;
}
.teams ::ng-deep.ibox-content table th .soryby_outer > div:nth-child(2) {
  bottom: 0;
}
.teams ::ng-deep.ibox-content table td {
  color: #676a6c;
}
.teams ::ng-deep.ibox-content table td.title-case span {
  border-radius: 2px;
  background-color: #676a6c;
  color: #fff;
  padding: 2px 4px 3px;
  font-size: 10px;
  font-weight: 700;
}
.teams ::ng-deep.ibox-content table td.one_one_adv a {
  display: inline-block;
  border: 2px solid rgb(105, 190, 40);
  color: rgb(105, 190, 40);
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: clamp(10px, 1vw, 14px);
  text-align: center;
  min-width: 100px;
}
.teams ::ng-deep.ibox-content table td.one_one_adv a:hover {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
.teams ::ng-deep.ibox-content table td a {
  color: inherit;
}
.teams ::ng-deep.ibox-content table td .no_pf {
  display: inline-block;
  background-color: #d4d4d4;
  color: #676a6c;
  padding: 4px;
  font-size: 10px;
  border-radius: 2px;
  font-weight: 700;
  text-align: center;
}
.teams ::ng-deep.ibox-content table .records_select {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 5px;
  margin-bottom: 0;
}
.teams ::ng-deep.ibox-content table .records_select label {
  margin-bottom: 0;
}
.teams ::ng-deep.ibox-content table .records_select select {
  width: min(70px, 100%);
}

::ng-deep .for-team-compo {
  display: none;
}

.f-m-inline-0 {
  margin-inline: 0 !important;
}

@media screen and (max-width: 1024px) {
  .f-col-sm-12 {
    width: 100%;
  }
}
span.sortby {
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 99999;
  text-align: right;
  position: absolute;
  padding-right: 14px;
}

.art_dropdown_right .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_15 .implement .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_15 .develop .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_13 .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_14 .circle.implement .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_4 .implement .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_12 .implement .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_10 .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_9 .implement .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_7 .implement .circle__dropdown {
  right: 0;
  left: auto;
}
.art_dropdown_right .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_15 .implement .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_15 .develop .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_13 .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_14 .circle.implement .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_4 .implement .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_12 .implement .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_10 .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_9 .implement .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_7 .implement .circle__dropdown::after {
  right: 17%;
  left: auto;
}

.art_dropdown_bottom .circle__dropdown, ::ng-deep.team_meet__col_art_grid.p_id_14 .circle.develop .circle__dropdown {
  top: calc(100% + 10px);
  right: 0;
  bottom: auto;
  left: auto;
}
.art_dropdown_bottom .circle__dropdown::after, ::ng-deep.team_meet__col_art_grid.p_id_14 .circle.develop .circle__dropdown::after {
  top: auto;
  right: 17%;
  bottom: 99%;
  left: auto;
  clip-path: polygon(50% 0, 100% 100%, 0 100%);
}

::ng-deep.team_meet {
  padding-block: 29px;
}
::ng-deep.team_meet--pd {
  padding-left: 3%;
  padding-right: 7%;
}
::ng-deep.team_meet > *:not(:last-child) {
  margin-bottom: 42px;
}
::ng-deep.team_meet__block {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
@media only screen and (max-width: 1199px) {
  ::ng-deep.team_meet__block {
    grid-template-columns: 1fr;
    grid-row-gap: 30px;
  }
}
::ng-deep.team_meet__col {
  padding: 49px 35px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__col {
    padding: 15px;
  }
}
::ng-deep.team_meet__col > :not(:last-child) {
  margin-bottom: 22px;
}
::ng-deep.team_meet__col--left {
  border-radius: 4px 0px 0px 4px;
  background-color: #f1f1f2;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__col--left {
    border-radius: 4px;
  }
}
::ng-deep.team_meet__col--right {
  border-radius: 0px 4px 4px 0px;
  border: 1px solid #e7eaec;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__col--right {
    border-radius: 4px;
  }
}
::ng-deep.team_meet__col--right .team_meet__col_art {
  border: 1px solid #e7eaec;
}
::ng-deep.team_meet__col_header {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 20px;
}
::ng-deep.team_meet__col_header_left {
  flex: 1;
}
::ng-deep.team_meet__col_header_left h2 {
  font-size: 24px;
  font-weight: 700;
  color: #676a6c;
}
::ng-deep.team_meet__col_header_left h2 span {
  display: block;
  font-size: 16px;
  line-height: 1.5;
}
::ng-deep.team_meet__col_header_right {
  width: 125px;
}
::ng-deep.team_meet__col_desc p,
::ng-deep.team_meet__col_desc li {
  color: #5c5d60;
  font-size: 14px;
  font-weight: 600;
  line-height: 157%;
}
::ng-deep.team_meet__col_desc p a,
::ng-deep.team_meet__col_desc li a {
  text-decoration: underline;
}
::ng-deep.team_meet__col_desc p button,
::ng-deep.team_meet__col_desc li button {
  background-color: transparent;
  border: 0;
  color: #337ab7;
  cursor: pointer;
}
::ng-deep.team_meet__col_art {
  border-radius: 4px;
  background-color: #fff;
}
::ng-deep.team_meet__col_art_header {
  border-bottom: 1px solid #e7eaec;
  padding: 10px 22px;
  color: #676a6c;
  font-size: 14px;
  font-weight: 700;
}
::ng-deep.team_meet__col_art_body {
  padding: clamp(20px, 6vw, 90px) 16px;
  text-align: center;
}
::ng-deep.team_meet__col_art_body img {
  max-width: 715px;
  width: 100%;
  display: block;
  margin-inline: auto;
}
::ng-deep.team_meet__col_art_body_wrapper {
  max-width: 715px;
  width: 100%;
  margin-inline: auto;
}
::ng-deep.team_meet__col_art_body_inner {
  margin-top: clamp(140px, 11vw, 150px);
  position: relative;
  padding-bottom: 28%;
}
::ng-deep.team_meet__col_art_grid {
  --lineHeight: 16%;
  --line_top_to_bottom: rotate(30deg);
  --line_bottom_to_top: rotate(-30deg);
  display: grid;
  grid-template-columns: repeat(4, 12%);
  justify-content: space-between;
  grid-gap: 20px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
::ng-deep.team_meet__col_art_grid.p_id_7 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_7 .clarify::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_7 .clarify .circle__dropdown {
  background-color: rgb(0, 173, 208);
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_7 .develop::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_7 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_7 .implement .circle__dropdown {
  background-color: rgb(245, 67, 89);
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_6 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_6 .clarify::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_6 .clarify .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_6 .ideate::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_6 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_6 .develop::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_6 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_1 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_1 .clarify::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_1 .clarify .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_3 .ideate::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_3 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_3 .develop::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_3 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_9 .clarify::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_9 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_9 .ideate::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_9 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_9 .develop::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_9 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_9 .implement .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_5 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_5 .clarify .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_5 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_5 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_5 .ideate::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_10 .ideate::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_10 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_10 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_10 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_10 .implement .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .clarify .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_11 .develop::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_12 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_12 .clarify .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_12 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_12 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_12 .ideate::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_12 .develop::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_12 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_12 .implement .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_2 .clarify::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_2 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_2 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_2 .ideate::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_4 .develop::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_4 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_4 .implement .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_14 .circle_dropdown_integrator {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_14 .circle {
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_13 .clarify::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_13 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_13 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_13 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_13 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_13 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_13 .implement .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_15 .clarify {
  background-color: rgb(0, 173, 208);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_15 .clarify::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_15 .clarify .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_15 .ideate::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_15 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_15 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_15 .implement {
  background-color: rgb(245, 67, 89);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_15 .implement .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_8 .clarify::before {
  transform: var(--line_bottom_to_top);
}
::ng-deep.team_meet__col_art_grid.p_id_8 .ideate {
  background-color: rgb(255, 121, 0);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_8 .ideate .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art_grid.p_id_8 .develop {
  background-color: rgb(105, 190, 40);
  align-self: start;
}
::ng-deep.team_meet__col_art_grid.p_id_8 .develop::before {
  transform: var(--line_top_to_bottom);
}
::ng-deep.team_meet__col_art_grid.p_id_8 .develop .circle__dropdown {
  display: block;
}
::ng-deep.team_meet__col_art .circle {
  width: 100%;
  aspect-ratio: 1;
  background: #f1f1f2;
  border-radius: 50%;
  align-self: end;
  position: relative;
}
::ng-deep.team_meet__col_art .circle:not(:last-child)::before {
  content: "";
  position: absolute;
  top: calc(50% - var(--lineHeight) / 2);
  height: var(--lineHeight);
  margin-block: auto;
  width: 235%;
  background: #f1f1f2;
  z-index: -1;
  transform-origin: left;
}
::ng-deep.team_meet__col_art .circle.clarify .circle__dropdown {
  background-color: rgb(0, 173, 208);
}
::ng-deep.team_meet__col_art .circle.ideate .circle__dropdown {
  background-color: rgb(255, 121, 0);
}
::ng-deep.team_meet__col_art .circle.develop .circle__dropdown {
  background-color: rgb(105, 190, 40);
}
::ng-deep.team_meet__col_art .circle.implement .circle__dropdown {
  background-color: rgb(245, 67, 89);
}
::ng-deep.team_meet__col_art .circle__dropdown {
  position: absolute;
  bottom: calc(100% + 10px);
  padding: 7px;
  border-radius: 5px;
  text-align: left;
  background: #f1f1f2;
  width: 230%;
  display: none;
}
::ng-deep.team_meet__col_art .circle__dropdown::after {
  content: "";
  position: absolute;
  top: 99%;
  left: 15%;
  width: 20px;
  height: 8px;
  background-color: inherit;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
}
::ng-deep.team_meet__col_art .circle__dropdown > *:first-child {
  margin-top: 0;
}
::ng-deep.team_meet__col_art .circle__dropdown > *:last-child {
  margin-bottom: 0;
}
::ng-deep.team_meet__col_art .circle__dropdown ul,
::ng-deep.team_meet__col_art .circle__dropdown ol {
  padding-left: 0;
}
::ng-deep.team_meet__col_art .circle__dropdown li {
  position: relative;
  list-style: none;
  padding-left: 8px;
}
::ng-deep.team_meet__col_art .circle__dropdown li::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 4px;
  aspect-ratio: 1;
  background-color: #fff;
  border-radius: 50%;
}
::ng-deep.team_meet__col_art .circle__dropdown p,
::ng-deep.team_meet__col_art .circle__dropdown li {
  font-size: clamp(8px, 1vw, 14px);
  line-height: 1.3;
  font-weight: 600;
  color: #fff;
}
::ng-deep.team_meet__col_art .circle__dropdown p:not(:last-child),
::ng-deep.team_meet__col_art .circle__dropdown li:not(:last-child) {
  margin-bottom: 5px;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator {
  position: absolute;
  bottom: calc(100% + 20px);
  left: 50%;
  transform: translateX(-50%);
  padding: 7px;
  border-radius: 5px;
  text-align: left;
  background: #676a6c;
  width: 27.597%;
  display: none;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator::after {
  content: "";
  position: absolute;
  top: 99%;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 8px;
  background-color: inherit;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator > *:first-child {
  margin-top: 0;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator > *:last-child {
  margin-bottom: 0;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator ul,
::ng-deep.team_meet__col_art .circle_dropdown_integrator ol {
  padding-left: 0;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator li {
  position: relative;
  list-style: none;
  padding-left: 8px;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator li::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 4px;
  aspect-ratio: 1;
  background-color: #fff;
  border-radius: 50%;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator p,
::ng-deep.team_meet__col_art .circle_dropdown_integrator li {
  font-size: clamp(8px, 1vw, 14px);
  line-height: 1.3;
  font-weight: 600;
  color: #fff;
}
::ng-deep.team_meet__col_art .circle_dropdown_integrator p:not(:last-child),
::ng-deep.team_meet__col_art .circle_dropdown_integrator li:not(:last-child) {
  margin-bottom: 5px;
}
::ng-deep.team_meet__challenges_header {
  border-radius: 4px 4px 0px 0px;
  background-color: #f1f1f2;
  padding: 9px 22px;
}
::ng-deep.team_meet__challenges_header > :last-child {
  margin-bottom: 0;
}
::ng-deep.team_meet__challenges_header h2 {
  font-size: 16px;
  font-weight: 700;
  color: #676a6c;
}
::ng-deep.team_meet__challenges_grid {
  --col_per_row: 4;
  display: grid;
  grid-template-columns: repeat(var(--col_per_row), 1fr);
  grid-gap: 18px;
  padding: 25px 41px;
  border: 1px solid #e7eaec;
  border-top: 0;
  border-radius: 0 0 4px 4px;
}
@media only screen and (max-width: 1199px) {
  ::ng-deep.team_meet__challenges_grid {
    --col_per_row: 2;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__challenges_grid {
    --col_per_row: 1;
    padding: 20px;
  }
}
::ng-deep.team_meet__challenges_col {
  border-radius: 4px;
  border: 1px solid #e7eaec;
  background-color: #fff;
  padding: 27px 20px 30px;
  text-align: center;
}
::ng-deep.team_meet__challenges_col > :last-child {
  margin-bottom: 0;
}
::ng-deep.team_meet__challenges_col h3 {
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 700;
}
::ng-deep.team_meet__challenges_col h3:not(:last-child) {
  margin-bottom: 18px;
}
::ng-deep.team_meet__challenges_col.clarify .team_meet__challenges_profile div.high {
  background-color: rgb(0, 173, 208);
}
::ng-deep.team_meet__challenges_col.ideate .team_meet__challenges_profile div.high {
  background-color: rgb(255, 121, 0);
}
::ng-deep.team_meet__challenges_col.develop .team_meet__challenges_profile div.high {
  background-color: rgb(105, 190, 40);
}
::ng-deep.team_meet__challenges_col.implement .team_meet__challenges_profile div.high {
  background-color: rgb(245, 67, 89);
}
::ng-deep.team_meet__challenges_profile {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  width: 111px;
  margin-inline: auto;
}
::ng-deep.team_meet__challenges_profile > div {
  aspect-ratio: 1;
  border-radius: 50%;
  background-color: #d9d9d9;
}
::ng-deep.team_meet__challenges_integrator {
  border: 1px solid #e7eaec;
  border-radius: 0 0 4px 4px;
}
::ng-deep.team_meet__challenges_integrator_inner {
  padding: 25px 41px;
}
::ng-deep.team_meet__challenges_integrator_inner > :not(:last-child) {
  margin-bottom: 27px;
  padding-bottom: 27px;
  border-bottom: 1px solid #e7eaec;
}
::ng-deep.team_meet__challenges_integrator_grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: min(1400px, 100%);
  margin-inline: auto;
  grid-row-gap: 10px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.team_meet__challenges_integrator_grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 30px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__challenges_integrator_grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
::ng-deep.team_meet__challenges_integrator_col {
  width: 111px;
  text-align: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.team_meet__challenges_integrator_col {
    width: 100%;
  }
}
::ng-deep.team_meet__challenges_integrator_col h3 {
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 700;
}
::ng-deep.team_meet__challenges_integrator_col h3:not(:last-child) {
  margin-bottom: 16px;
}
::ng-deep.team_meet__challenges_integrator_profile {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  width: 111px;
  margin-inline: auto;
}
::ng-deep.team_meet__challenges_integrator_profile > div {
  aspect-ratio: 1;
  background-color: #676a6c;
  border-radius: 50%;
}
::ng-deep.team_meet__challenges_integrator_profile.clarify div.high {
  background-color: rgb(0, 173, 208);
}
::ng-deep.team_meet__challenges_integrator_profile.ideate div.high {
  background-color: rgb(255, 121, 0);
}
::ng-deep.team_meet__challenges_integrator_profile.develop div.high {
  background-color: rgb(105, 190, 40);
}
::ng-deep.team_meet__challenges_integrator_profile.implement div.high {
  background-color: rgb(245, 67, 89);
}
::ng-deep.team_meet__challenges_integrator_info {
  text-align: center;
  width: min(647px, 100%);
  margin-inline: auto;
}
::ng-deep.team_meet__challenges_integrator_info p {
  font-size: 14px;
  font-weight: 600;
  color: #676a6c;
}
::ng-deep.team_meet__agreement_header {
  border-radius: 4px 4px 0px 0px;
  background-color: #f1f1f2;
  padding: 9px 22px;
}
::ng-deep.team_meet__agreement_header h3 {
  font-size: 16px;
  font-weight: 700;
  color: #676a6c;
}
::ng-deep.team_meet__agreement_body {
  border-radius: 0px 0px 4px 4px;
  border: 1px solid #e7eaec;
}
::ng-deep.team_meet__agreement_tab_nav ul {
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #e7eaec;
}
::ng-deep.team_meet__agreement_tab_nav ul li {
  list-style: none;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__agreement_tab_nav ul li {
    width: 100%;
  }
}
@media only screen and (min-width: 768px) {
  ::ng-deep.team_meet__agreement_tab_nav ul li:not(:last-child) {
    border-right: 1px solid #e7eaec;
  }
}
::ng-deep.team_meet__agreement_tab_nav button {
  color: #676a6c;
  font-size: 12px;
  font-weight: 600;
  opacity: 0.9;
  min-width: 219px;
  border: 0;
  background-color: transparent;
  padding: 9px 23px;
  position: relative;
  border-radius: 0;
  cursor: pointer;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.team_meet__agreement_tab_nav button {
    width: 100%;
  }
}
::ng-deep.team_meet__agreement_tab_nav button.active {
  font-weight: 700;
}
::ng-deep.team_meet__agreement_tab_nav button.active::after {
  opacity: 1;
}
::ng-deep.team_meet__agreement_tab_nav button::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgb(105, 190, 40);
  height: 2px;
  opacity: 0;
}
::ng-deep.team_meet__agreement_tab_content {
  padding: 24px 20px;
}
::ng-deep.team_meet__agreement_tab_content form > *:not(:last-child) {
  margin-bottom: 16px;
}
::ng-deep.team_meet__agreement_tab_content input,
::ng-deep.team_meet__agreement_tab_content textarea {
  border-radius: 4px;
  border: 1px solid #e7eaec;
  height: 122px;
  resize: none;
  padding: 11px 15px;
  width: 100%;
}
::ng-deep.team_meet__agreement_tab_content input:focus,
::ng-deep.team_meet__agreement_tab_content textarea:focus {
  outline: none;
}
::ng-deep.team_meet__agreement_tab_content input {
  height: 34px;
}
::ng-deep.team_meet__agreement_tab_content input[type=submit] {
  border-radius: 4px;
  background: rgb(105, 190, 40);
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  color: #fff;
  border: 0;
  width: auto;
  padding: 7px 27px;
  cursor: pointer;
  transition: 0.3s;
}
::ng-deep.team_meet__agreement_tab_content input[type=submit]:hover {
  background-color: #676a6c;
}

::ng-deep._no_profile_ {
  height: 18px;
  width: 18px;
  border-radius: 50%;
  color: #ff485c;
  font-size: 8px;
  background: #f1f1f2;
}
::ng-deep._no_profile_._bgw_ {
  background-color: #fff;
}

::ng-deep.missing-profiles {
  background-color: #d9d9d9;
}
::ng-deep.missing-profiles h5,
::ng-deep.missing-profiles i {
  color: #676a6c;
}

.advice_sidebar {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  width: calc(100% - 70px);
  max-width: 240px;
  background-color: #fff;
  z-index: 999;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.05);
}
.advice_sidebar__wrapper {
  padding: 10px;
}
.advice_sidebar__header {
  background-color: #f1f1f2;
  padding: 10px 35px 10px 15px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 700;
  color: #676a6c;
  position: relative;
}
.advice_sidebar__header:not(:last-child) {
  margin-bottom: 15px;
}
.advice_sidebar__list {
  padding-inline: 15px;
}
.advice_sidebar__list > :not(:last-child) {
  margin-bottom: 15px;
}
.advice_sidebar__list h5 {
  font-weight: 700;
  font-size: 14px;
  margin-top: 0;
}
.advice_sidebar__list h5:not(:last-child) {
  margin-bottom: 5px;
}
.advice_sidebar__list ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.advice_sidebar__list p,
.advice_sidebar__list li {
  font-weight: 600;
  font-size: 12px;
}
.advice_sidebar__list p:not(:last-child),
.advice_sidebar__list li:not(:last-child) {
  margin-bottom: 10px;
}
.advice_sidebar__close {
  --line_thickness: 2px;
  --line_length: 70%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10px;
  margin-block: auto;
  width: 18px;
  aspect-ratio: 1;
  background-color: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;
}
.advice_sidebar__close:hover > div::before, .advice_sidebar__close:hover > div::after {
  background-color: rgb(105, 190, 40);
}
.advice_sidebar__close div {
  position: absolute;
  inset: 0;
  transform: rotate(45deg);
}
.advice_sidebar__close div::before, .advice_sidebar__close div::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #676a6c;
  transition: all ease 0.3s;
}
.advice_sidebar__close div::before {
  width: var(--line_thickness);
  height: var(--line_length);
}
.advice_sidebar__close div::after {
  width: var(--line_length);
  height: var(--line_thickness);
}

::ng-deep.fa-chevron-up {
  transition: all 0.3s ease;
}
::ng-deep.fa-chevron-up.active {
  transform: rotate(180deg);
}

.txt_trnsfrm {
  text-transform: capitalize;
}

.counter {
  display: block;
  text-align: left;
  font-weight: normal;
  padding-top: 2px;
  font-size: 10px;
}

.gap10 {
  gap: 10px;
}

.prt_view {
  background-color: #d9d9d9;
}
.prt_view h3 {
  color: #ff485c;
  font-weight: bold;
}
.prt_view .userProfile__team__accord_header {
  z-index: 999;
}

.caps {
  text-transform: capitalize;
}

.gap30 {
  gap: 30px;
}

.teams__plan {
  border-top: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/teams/participants-view/participants-view.component.scss","webpack://./src/app/components/teams/teams.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AD/QA;EACE,eAAA;ACkRF;;AD/QA;EACE,aAAA;EACA,eAAA;ACkRF;;AD/QA;EACE,sBAAA;ACkRF;;AD/QA;EACE,8BAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;AD/QA;EACE,aAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;ADpQE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ACuQJ;ADrQI;;;;;;EACE,gBAAA;AC4QN;ADxQE;;EAEE,eA5GO;EA6GP,gBA3GO;ACqXX;ADxQI;EALF;;IAMI,eA/GY;EC2XhB;AACF;ADzQE;;EAEE,eAlHO;EAmHP,gBAjHO;AC4XX;ADzQI;EALF;;IAMI,eArHY;ECkYhB;AACF;AD1QE;;EAEE,eAxHO;EAyHP,gBAvHO;ACmYX;AD1QI;EALF;;IAMI,eA3HY;ECyYhB;AACF;AD3QE;;EAEE,eA9HO;EA+HP,gBA7HO;AC0YX;AD1QE;;EAEE,eAhIO;EAiIP,gBAhIO;AC4YX;ADzQE;;EAEE,eAnIO;EAoIP,gBAnIO;AC8YX;ADrQE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ACuQJ;ADrQI;EACE,gBAAA;ACuQN;ADpQI;EAXF;IAYI,eAAA;ECuQJ;AACF;ADpQE;;EAEE,UAAA;EACA,SAAA;ACsQJ;ADnQE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ACqQJ;;ADjQA;EACE,sBAxNQ;AC4dV;;ADjQA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ACoQF;ADlQE;EALF;IAMI,cAAA;ECqQF;AACF;ADnQE;EACE,iBA1Ka;AC+ajB;ADlQE;EACE,gBApLa;EAqLb,WAAA;ACoQJ;;AD/PE;EACE,kBAAA;ACkQJ;AD/PE;EACE,iBAAA;ACiQJ;;AD5PE;EACE,aAAA;AC+PJ;;AD3PA;EACE,kBAAA;AC8PF;AD5PE;EACE,mBAAA;AC8PJ;AD1PI;EACE,sBAAA;AC4PN;ADxPE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACwdnB;ADxPI;EACE,sBAAA;AC0PN;ADvPI;EAVF;IAWI,eApOoB;EC8dxB;AACF;ADvPE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACyPJ;ADvPI;EACE,sBAAA;ACyPN;ADtPI;EACE,WAAA;ACwPN;ADrPI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACmlBZ;;ADlPA;EACE,mBA1PO;AC+eT;ADnPE;EAHF;IAII,mBAAA;ECsPF;AACF;ADpPE;EACE,mBAAA;ACsPJ;ADnPE;EACE,aArQK;AC0fT;ADnPI;EAHF;IAII,aAAA;ECsPJ;AACF;ADpPI;EACE,aAAA;ACsPN;;ADjPA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ACoPF;ADlPE;EACE,eAAA;ACoPJ;ADjPE;EACE,sCAAA;ACmPJ;ADhPE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;ACkPJ;;ADnOE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ACsOJ;ADpOI;EACE,kBAAA;ACsON;ADnOI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ACqON;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,+BAAA;ACmOF;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;ACmOF;ADjOE;EACE,2BAAA;EACA,mBAAA;ACmOJ;ADhOE;EACE,yBAzbiB;EA0bjB,WA1aO;AC4oBX;AD/NE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;ACiOJ;AD9NE;EACE,yBAjckB;EAkclB,cArciB;ACqqBrB;AD7NE;EACE,yBAvbS;EAwbT,WA1bO;ACypBX;AD7NI;EACE,6BAAA;AC+NN;;AD1NA;EACE;IACE,uBAAA;EC6NF;ED1NA;IACE,yBAAA;EC4NF;AACF;ADzNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,+BAAA;AC2NF;;ADxNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,qBAAA;AC2NF;;ADxNA;EACE,UAAA;AC2NF;ADzNE;EACE,qBAAA;AC2NJ;;ADvNA;EACE,UAAA;AC0NF;;ADtNE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACwNJ;ADrNM;EACE,mBAAA;ACuNR;ADlNE;EACE,2BAAA;ACoNJ;ADjNE;EACE,uBAAA;ACmNJ;ADhNE;EACE,mBAAA;ACkNJ;;AD7ME;EACE,mBAAA;ACgNJ;AD7ME;EACE,yBAAA;AC+MJ;AD5ME;EACE,sBAAA;AC8MJ;AD3ME;EACE,uBAAA;AC6MJ;AD1ME;EACE,oBAAA;AC4MJ;;AC7xBA;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;ADgyBF;;AC7xBA;EACE,yBAAA;EACA,kBAAA;ADgyBF;;AC7xBA;EACE,cAAA;ADgyBF;;AC7xBA;EACE,yBAAA;EACA,cAAA;ADgyBF;;AC7xBA;EACE,eAAA;ADgyBF;;AC7xBA;EACE,iBAAA;EACA,mBAAA;ADgyBF;;AC5xBE;EACE,kBAAA;AD+xBJ;AC7xBI;EACE,sBAAA;AD+xBN;AC5xBI;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WFgBa;EEfb,2BAAA;EACA,6BAAA;EACA,mCAAA;EACA,2CAAA;AD8xBN;AC1xBM;EACE,cAAA;AD4xBR;;ACrxBE;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;ADwxBJ;ACtxBI;EACE,wBF3DU;ACm1BhB;ACrxBI;EAdF;IAeI,oBAAA;EDwxBJ;AACF;ACtxBI;EACE,SAAA;ADwxBN;ACrxBI;EACE,iBAAA;EACA,gBAAA;ADuxBN;ACrxBM;EAJF;IAKI,oBAAA;EDwxBN;AACF;ACrxBQ;EACE,eAAA;EACA,gBAAA;ADuxBV;AClxBI;EACE,6BAAA;EACA,4BAAA;ADoxBN;ACjxBI;EACE,iBAAA;EACA,eAAA;ADmxBN;ACjxBM;EACE,WAAA;EACA,gBAAA;ADmxBR;AC7wBI;EACE,WAAA;AD+wBN;AC7wBM;EACE,eAAA;EACA,gBAAA;EACA,cFjGa;EEkGb,aAAA;AD+wBR;AC7wBQ;EACE,eAAA;AD+wBV;AC3wBM;EACE,eAAA;AD6wBR;ACzwBI;EACE,qBAAA;AD2wBN;ACxwBQ;EACE,6BAAA;EACA,UAAA;EACA,cFrHW;EEsHX,qBAzJK;ADm6Bf;ACxwBU;EACE,qBAAA;EACA,iBAAA;AD0wBZ;ACxwBY;EACE,+BAAA;AD0wBd;ACjwBI;EACE,yBAAA;EACA,yBAAA;ADmwBN;AC/vBU;EACE,yBFrIU;ACs4BtB;AC9vBU;EACE,yBAAA;ADgwBZ;AC7vBU;EACE,SAAA;AD+vBZ;AC1vBM;EACE,aAAA;AD4vBR;AC1vBQ;EACE,kBAAA;EACA,eAAA;AD4vBV;AC1vBU;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AD4vBZ;ACxvBQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,+BAAA;EACA,gCAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;AD0vBV;;ACnvBA;EACE,sBAAA;EACA,cF/LmB;EEgMnB,SAAA;ADsvBF;;ACnvBA;EACE,kBAAA;ADsvBF;;ACnvBA;EACE,yBFhMoB;ACs7BtB;;ACnvBA;EACE,cF5MmB;ACk8BrB;;ACnvBA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBFpNmB;EEqNnB,kBAAA;EACA,WAAA;ADsvBF;ACpvBE;EACE,iCAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;ADsvBJ;;AClvBA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;ADqvBF;ACnvBE;EACE,0BAAA;EACA,yBAAA;ADqvBJ;AClvBE;EACE,SAAA;ADovBJ;AChvBI;EACE;IACE,WAAA;EDkvBN;AACF;AC9uBE;EACE,mBAAA;ADgvBJ;AC9uBI;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;ADgvBN;AC9uBM;EACE,kBAAA;EACA,YAAA;ADgvBR;AC7uBM;EACE,gBAAA;AD+uBR;AC5uBM;EACE,yBFjQc;EEkQd,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AD8uBR;AC7uBQ;EACE,kBAAA;EACA,YAAA;AD+uBV;AC5uBQ;EACE,cFpRW;EEqRX,aAAA;EACA,eAAA;AD8uBV;AC1uBM;EACE,kBAAA;EACA,kBAAA;AD4uBR;AC1uBQ;EAEE,mBAAA;AD2uBV;ACxuBQ;EACE,6BAAA;AD0uBV;ACvuBQ;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;ADyuBV;ACvuBU;EACE,gBAAA;ADyuBZ;ACruBQ;EACE,aAAA;ADuuBV;ACpuBQ;EACE,cFtTW;AC4hCrB;ACnuBQ;;EAEE,kBAAA;EACA,UAAA;ADquBV;ACnuBU;;EACE,mBAAA;ADsuBZ;ACluBQ;EACE,gBAAA;EACA,eAAA;ADouBV;ACjuBQ;;EAEE,gBAAA;EACA,eAAA;ADmuBV;AChuBQ;EACE,gBAAA;EACA,6BAAA;EACA,cAAA;ADkuBV;AC/tBQ;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,OAAA;EACA,sDAAA;EACA,iBAAA;ADiuBV;AC3sBU;EACE,gCAAA;EACA,kBAAA;EACA,mBAAA;AD6sBZ;AC1sBU;EACE;IACE,UAAA;IACA,WAAA;IACA,gBAAA;ED4sBZ;AACF;ACxsBY;EACE,wBF7YE;ACulChB;ACvsBY;EACE,iBAAA;ADysBd;ACpsBQ;EACE,aAAA;EACA,qCAAA;EACA,cAAA;ADssBV;ACpsBU;EALF;IAMI,qCAAA;EDusBV;AACF;ACpsBY;EACE,kCFnaE;ACymChB;ACnsBY;EACE,cFzZO;EE0ZP,gBAAA;ADqsBd;ACnsBc;EACE,uBF3aA;ACgnChB;AC/rBY;EACE,kCFjbC;ACknCf;AC9rBY;EACE,cFxaO;EEyaP,gBAAA;ADgsBd;AC9rBc;EACE,uBFzbD;ACynCf;AC1rBY;EACE,mCF/bE;AC2nChB;ACzrBY;EACE,cFvbO;EEwbP,gBAAA;AD2rBd;ACzrBc;EACE,wBFvcA;ACkoChB;ACrrBY;EACE,kCF7cI;ACooClB;ACprBY;EACE,cFtcO;EEucP,gBAAA;ADsrBd;ACprBc;EACE,uBFrdE;AC2oClB;ACjrBU;EACE,iBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;ADmrBZ;ACjrBY;EACE,mBAAA;ADmrBd;AC/qBU;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;ADirBZ;AC/qBY;EACE,kBAAA;ADirBd;AC9qBY;EACE,WAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBFreQ;EEseR,gBAAA;ADgrBd;AC5qBU;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AD8qBZ;AC5qBY;EACE,mBAAA;AD8qBd;AC3qBY;EACE,kBAAA;AD6qBd;ACvqBI;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;ADyqBN;ACnqBM;EACE,UAAA;ADqqBR;ACjqBI;EACE,yBFzgBgB;EE0gBhB,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cFrhBe;EEshBf,0BAAA;ADmqBN;ACjqBM;EACE,gBAAA;ADmqBR;ACjqBQ;EACE,aAAA;ADmqBV;AChqBQ;EACE,kBAAA;ADkqBV;AChqBU;EACE,eAAA;ADkqBZ;AChqBY;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;ADkqBd;AChqBc;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,yCAAA;EACA,sBFniBL;EEoiBK,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;ADkqBhB;AC1pBI;EACE,UAAA;EACA,iBAAA;AD4pBN;AC3pBM;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,oBAAA;EACA,SAAA;AD6pBR;AC1pBM;EACE,cFhlBa;EEilBb,YAAA;AD4pBR;AC1pBQ;EACE,mBAAA;EACA,+BAAA;AD4pBV;AC1pBU;EACE,eAAA;AD4pBZ;ACzpBU;EACE,wCAAA;EACA,2BAAA;AD2pBZ;ACtpBM;EACE,kBAAA;EACA,YAAA;ADwpBR;ACtpBQ;EACE,iBAAA;EACA,SAAA;ADwpBV;ACrpBQ;EACE,yBAAA;ADupBV;ACppBQ;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;ADspBV;ACnpBQ;EACE,cF5nBW;EE6nBX,SAAA;EACA,wEAAA;EAEA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;ADopBV;ACjpBQ;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;ADmpBV;AC9oBI;EACE,UAAA;EACA,iBAAA;ADgpBN;AC5oBE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AD8oBJ;AC5oBI;EACE,gBAAA;EACA,SAAA;AD8oBN;AC3oBI;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;AD6oBN;AC3oBM;EALF;IAMI,UAAA;ED8oBN;AACF;AC1oBE;EACE,0BAAA;AD4oBJ;;ACtoBI;EACE,gBAAA;ADyoBN;ACroBE;EACE,aAAA;EACA,SAAA;EACA,yDAAA;EACA,sCAAA;ADuoBJ;ACroBI;EANF;IAOI,0BAAA;EDwoBJ;AACF;ACroBE;EACE,sBAAA;EACA,iBAAA;ADuoBJ;ACpoBE;EACE,yBAAA;EACA,kBAAA;ADsoBJ;ACnoBE;EACE,0BAAA;EACA,yBAAA;ADqoBJ;ACjoBI;EADF;IAEI,UAAA;EDooBJ;AACF;ACloBI;EALF;IAMI,WAAA;EDqoBJ;AACF;ACjoBI;EADF;IAEI,WAAA;EDooBJ;AACF;ACjoBE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;ADmoBJ;ACjoBI;EALF;IAMI,eAAA;EDooBJ;AACF;ACjoBM;EACE,UAAA;EACA,mCF3vBQ;AC83ChB;AC9nBE;EACE,yBF7uBkB;EE8uBlB,0BAAA;EACA,0BAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;ADgoBJ;AC9nBI;EACE,sBFzuBK;ACy2CX;AC7nBI;EACE,yBAAA;AD+nBN;AC5nBI;EACE,eAAA;EACA,wEF1yBO;EE2yBP,cFxwBe;EEywBf,gBAAA;EACA,OAAA;AD8nBN;AC5nBM;EACE,0BAAA;EACA,qBAAA;AD8nBR;ACznBU;EACE,aAAA;AD2nBZ;ACznBU;EACE,qBAAA;AD2nBZ;ACvnBQ;EACE,aAAA;ADynBV;ACrnBM;EACE,SAAA;ADunBR;ACrnBQ;EACE,WAAA;EACA,yBFryBW;EEsyBX,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;ADunBV;ACrnBU;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;ADunBZ;ACnnBY;EACE,cAAA;ADqnBd;AC9mBI;EACE,yBF/zBa;EEg0Bb,WFtzBK;EEuzBL,gBAAA;EACA,YAAA;EACA,eAAA;ADgnBN;AC7mBI;EACE,sBF7zBK;EE8zBL,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cFv1Be;EEw1Bf,wEF33BO;EE43BP,gBAAA;AD+mBN;AC5mBI;EACE,YAAA;EACA,mBAAA;AD8mBN;AC1mBE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AD4mBJ;AC1mBI;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;AD4mBN;ACzmBI;EACE,6BAAA;AD2mBN;ACxmBI;EACE,cAAA;EACA,sBAAA;AD0mBN;ACvmBI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;ADymBN;ACvmBM;EACE,cAAA;ADymBR;ACtmBM;EACE,sBAAA;EACA,mBAAA;EACA,UAAA;EACA,qBAAA;ADwmBR;ACrmBM;EACE,+BAAA;ADumBR;ACrmBQ;EACE,eAAA;ADumBV;ACnmBM;EACE,cAAA;ADqmBR;AClmBM;EACE,aAAA;ADomBR;AClmBQ;EACE,qBAAA;ADomBV;AChmBM;EACE,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;ADkmBR;AChmBQ;EACE,6BAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;ADkmBV;AC9lBM;EAxDF;IAyDI,WAAA;EDimBN;AACF;AC/lBM;EACE,UAAA;EACA,iBAAA;EACA,iBAAA;ADimBR;AC7lBI;EACE,iBAAA;EACA,WAAA;AD+lBN;AC5lBI;EACE,cFj8Be;EEk8Bf,eAAA;EACA,gBAAA;AD8lBN;ACxlBM;EAHF;IAII,iBAAA;ED2lBN;AACF;ACvlBE;EACE,aAAA;ADylBJ;ACvlBI;EACE,UAAA;EACA,yBAAA;EACA,yBAAA;EACA,gBAAA;ADylBN;ACvlBM;;EAEE,oCAAA;EACA,YAAA;EACA,eAAA;ADylBR;ACvlBQ;;EACE,kBAAA;AD0lBV;ACtlBM;EACE,gBAAA;ADwlBR;ACrlBM;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;ADulBR;ACrlBQ;EACE,gBAAA;ADulBV;ACnlBM;EACE,sBAAA;ADqlBR;ACnlBQ;EACE,aAAA;ADqlBV;AC/kBE;EACE,aAAA;ADilBJ;AC/kBI;EACE,UAAA;ADilBN;AC/kBM;EACE,iBAAA;ADilBR;AC/kBQ;EACE,mBAAA;ADilBV;AC9kBQ;EACE,eAAA;EACA,gBAAA;ADglBV;AC5kBM;EACE,SAAA;EACA,mBAAA;AD8kBR;AC5kBQ;EACE,kBAAA;AD8kBV;AClkBE;EACE,aAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;ADokBJ;AClkBI;EACE,OAAA;EACA,SAAA;EACA,cF1iCe;EE2iCf,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;ADokBN;AClkBM;EACE,yBFtiCO;AC0mDf;AC7jBM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,mCF1kCY;EE2kCZ,UAAA;AD+jBR;AC5jBM;EACE,+BAAA;AD8jBR;ACzjBE;EACE,iCAAA;EACA,WAAA;AD2jBJ;ACzjBI;EACE,cFjlCe;EEklCf,yBFvkCa;EEwkCb,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AD2jBN;ACtjBI;EACE,UAAA;ADwjBN;ACrjBI;EACE,cAAA;ADujBN;ACpjBI;EACE,cAAA;ADsjBN;ACnjBI;EACE,oBAAA;EACA,mBAAA;ADqjBN;ACjjBE;EACE,WAAA;EACA,6BAAA;ADmjBJ;ACjjBI;EACE,eAAA;EACA,gBAAA;ADmjBN;AChjBI;EACE,eAAA;EACA,YAAA;ADkjBN;AC/iBI;EACE,yBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;ADijBN;AC/iBM;EACE,aAAA;ADijBR;AC5iBI;EACE,cAAA;EACA,iBAAA;AD8iBN;AC3iBI;EACE,iBAAA;AD6iBN;AC1iBI;EACE,yBAAA;EACA,aAAA;EACA,oBAAA;AD4iBN;ACtiBM;EACE,oBAAA;ADwiBR;ACriBM;EACE,0BAAA;ADuiBR;ACpiBM;EACE,SAAA;EACA,eAAA;ADsiBR;ACniBM;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;ADqiBR;ACliBM;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;ADoiBR;ACjiBM;EACE,cF/rCa;EEgsCb,SAAA;EACA,wEAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;ADmiBR;AChiBM;EACE,gCAAA;ADkiBR;AC9hBQ;;EAEE,0BAAA;ADgiBV;AC7hBQ;EACE,eAAA;AD+hBV;AC1hBI;EACE,oBAAA;AD4hBN;ACzhBI;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;AD2hBN;ACvhBE;EACE,yBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;ADyhBJ;ACvhBI;EACE,SAAA;ADyhBN;ACrhBE;EACE,aAAA;ADuhBJ;ACnhBQ;EACE,aAAA;ADqhBV;ACjhBM;EACE,aAAA;EACA,uBAAA;ADmhBR;AC/gBU;EACE,kCAAA;EACA,kCF/wCI;EEgxCJ,kCAAA;EACA,4BAAA;ADihBZ;AC3gBU;EACE,kCAAA;EACA,kCFxxCG;EEyxCH,kCAAA;EACA,4BAAA;AD6gBZ;ACvgBU;EACE,mCAAA;EACA,mCFjyCI;EEkyCJ,mCAAA;EACA,4BAAA;ADygBZ;ACngBU;EACE,kCAAA;EACA,kCF1yCM;EE2yCN,kCAAA;EACA,4BAAA;ADqgBZ;ACjgBQ;EACE,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;ADmgBV;AClgBU;EATF;IAUI,uBAAA;IACA,sBAAA;EDqgBV;AACF;ACjgBM;EACE,oCAAA;ADmgBR;AChgBM;EACE,oCAAA;ADkgBR;AC/fM;EACE,oCAAA;ADigBR;AC9fM;EACE,oCAAA;ADggBR;AC7fM;EACE,oCAAA;AD+fR;AC5fM;EACE,oCAAA;AD8fR;AC3fM;EACE,oCAAA;AD6fR;AC1fM;EACE,oCAAA;AD4fR;ACxfI;EACE,UAAA;AD0fN;ACvfI;EACE,yBAAA;EACA,eAAA;ADyfN;ACvfM;EACE,yBFj1CO;EEk1CP,YAAA;EACA,eAAA;ADyfR;ACpfU;EACE,qBAAA;EACA,+BAAA;EACA,YAAA;ADsfZ;AC/eE;EACE,SAAA;ADifJ;AC/eI;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBF/2CgB;EEg3ChB,0BAAA;ADifN;AC/eM;EACE,WAAA;EACA,eAAA;EACA,gBAAA;ADifR;AC/eQ;EACE,gBAAA;ADifV;AC5eQ;EACE,aAAA;AD8eV;ACzeI;EACE,UAAA;EACA,yBAAA;EACA,0BAAA;AD2eN;ACzeM;EACE,gBAAA;AD2eR;ACzeQ;EACE,eAAA;EACA,cFr5CW;ACg4DrB;ACzeU;EACE,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AD2eZ;ACzeY;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;AD2ed;ACzec;EACE,MAAA;AD2ehB;ACxec;EACE,SAAA;AD0ehB;ACpeQ;EACE,cFj7CW;ACu5DrB;ACneY;EACE,kBAAA;EACA,yBFt7CO;EEu7CP,WFl6CH;EEm6CG,oBAAA;EACA,eAAA;EACA,gBAAA;ADqed;ACheY;EACE,qBAAA;EACA,mCAAA;EACA,wBF98CE;EE+8CF,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;ADked;AChec;EACE,mCFv9CA;EEw9CA,WFv7CL;ACy5DX;AC7dU;EACE,cAAA;AD+dZ;AC5dU;EACE,qBAAA;EACA,yBAAA;EACA,cFx9CS;EEy9CT,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AD8dZ;AC1dQ;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AD4dV;AC1dU;EACE,gBAAA;AD4dZ;ACzdU;EACE,sBAAA;AD2dZ;;ACndA;EACE,aAAA;ADsdF;;ACndA;EACE,2BAAA;ADsdF;;ACpdA;EACE;IACE,WAAA;EDudF;AACF;ACrdA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;ADudF;;ACndE;EACE,QAAA;EACA,UAAA;ADsdJ;ACpdI;EACE,UAAA;EACA,UAAA;ADsdN;;AChdE;EACE,sBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;ADmdJ;ACjdI;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,4CAAA;ADmdN;;AC9cA;EACE,mBAAA;ADidF;AChdE;EACE,gBAAA;EACA,iBAAA;ADkdJ;AC/cE;EACE,mBAAA;ADidJ;AC9cE;EACE,aAAA;EACA,qCAAA;ADgdJ;AC9cI;EAJF;IAKI,0BAAA;IACA,kBAAA;EDidJ;AACF;AC9cE;EACE,kBAAA;ADgdJ;AC9cI;EAHF;IAII,aAAA;EDidJ;AACF;AC/cI;EACE,mBAAA;ADidN;AC9cI;EACE,8BAAA;EACA,yBFlkDgB;ACkhEtB;AC9cM;EAJF;IAKI,kBAAA;EDidN;AACF;AC9cI;EACE,8BAAA;EACA,yBAAA;ADgdN;AC9cM;EAJF;IAKI,kBAAA;EDidN;AACF;AC/cM;EACE,yBAAA;ADidR;AC7cI;EACE,aAAA;EACA,eAAA;EACA,cAAA;AD+cN;AC7cM;EACE,OAAA;AD+cR;AC7cQ;EACE,eAAA;EACA,gBAAA;EACA,cFzmDW;ACwjErB;AC7cU;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AD+cZ;AC1cM;EACE,YAAA;AD4cR;ACvcM;;EAEE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ADycR;ACvcQ;;EACE,0BAAA;AD0cV;ACvcQ;;EACE,6BAAA;EACA,SAAA;EACA,cFtmDK;EEumDL,eAAA;AD0cV;ACrcI;EACE,kBAAA;EACA,sBAAA;ADucN;ACrcM;EACE,gCAAA;EACA,kBAAA;EACA,cFppDa;EEqpDb,eAAA;EACA,gBAAA;ADucR;ACpcM;EACE,oCAAA;EACA,kBAAA;ADscR;ACpcQ;EACE,gBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;ADscV;ACncQ;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;ADqcV;AClcQ;EACE,qCAAA;EACA,kBAAA;EACA,mBAAA;ADocV;AChcM;EACE,iBAAA;EACA,mCAAA;EACA,oCAAA;EACA,aAAA;EACA,qCAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;ADkcR;AC/bU;EACE,kCFhtDI;EEitDJ,iBAAA;ADicZ;AC/bY;EACE,oCAAA;ADicd;AC9bY;EACE,kCFxtDE;EEytDF,cAAA;ADgcd;AC3bY;EACE,oCAAA;AD6bd;ACzbU;EACE,kCFjuDM;EEkuDN,iBAAA;AD2bZ;ACvbY;EACE,kCFvuDI;EEwuDJ,cAAA;ADybd;ACnbU;EACE,kCFlvDI;EEmvDJ,iBAAA;ADqbZ;ACnbY;EACE,oCAAA;ADqbd;AClbY;EACE,cAAA;ADobd;AC/aY;EACE,oCAAA;ADibd;AC7aU;EACE,mCFnwDI;EEowDJ,iBAAA;AD+aZ;AC7aY;EACE,oCAAA;AD+ad;AC5aY;EACE,cAAA;AD8ad;ACxaU;EACE,kCFpxDI;EEqxDJ,iBAAA;AD0aZ;ACxaY;EACE,oCAAA;AD0ad;ACvaY;EACE,cAAA;ADyad;AClaY;EACE,oCAAA;ADoad;AChaU;EACE,mCFvyDI;EEwyDJ,iBAAA;ADkaZ;AChaY;EACE,oCAAA;ADkad;AC/ZY;EACE,cAAA;ADiad;AC1ZY;EACE,oCAAA;AD4Zd;ACxZU;EACE,kCF7zDG;EE8zDH,iBAAA;AD0ZZ;ACxZY;EACE,oCAAA;AD0Zd;ACvZY;EACE,cAAA;ADyZd;ACpZY;EACE,oCAAA;ADsZd;AClZU;EACE,kCF90DM;EE+0DN,iBAAA;ADoZZ;AChZY;EACE,cAAA;ADkZd;AC5YU;EACE,kCF91DI;EE+1DJ,iBAAA;AD8YZ;AC5YY;EACE,cAAA;AD8Yd;AC1YU;EACE,kCFt2DG;EEu2DH,iBAAA;AD4YZ;AC1YY;EACE,cAAA;AD4Yd;ACzYY;EACE,oCAAA;AD2Yd;AClYY;EACE,oCAAA;ADoYd;AChYU;EACE,mCF53DI;EE63DJ,iBAAA;ADkYZ;AChYY;EACE,cAAA;ADkYd;AC9XU;EACE,kCFp4DM;EEq4DN,iBAAA;ADgYZ;AC9XY;EACE,cAAA;ADgYd;AC1XU;EACE,kCFl5DI;EEm5DJ,iBAAA;AD4XZ;AC1XY;EACE,cAAA;AD4Xd;ACxXU;EACE,kCF15DG;EE25DH,iBAAA;AD0XZ;ACxXY;EACE,cAAA;AD0Xd;ACtXU;EACE,mCFl6DI;EEm6DJ,iBAAA;ADwXZ;ACtXY;EACE,cAAA;ADwXd;ACrXY;EACE,oCAAA;ADuXd;ACjXU;EACE,kCFn7DI;EEo7DJ,iBAAA;ADmXZ;ACjXY;EACE,cAAA;ADmXd;AC/WU;EACE,kCF37DG;EE47DH,iBAAA;ADiXZ;AC/WY;EACE,cAAA;ADiXd;AC9WY;EACE,oCAAA;ADgXd;AC3WY;EACE,oCAAA;AD6Wd;ACzWU;EACE,kCF58DM;EE68DN,iBAAA;AD2WZ;ACvWY;EACE,cAAA;ADyWd;AClWY;EACE,oCAAA;ADoWd;AChWU;EACE,kCFj+DG;EEk+DH,iBAAA;ADkWZ;AChWY;EACE,cAAA;ADkWd;AC/VY;EACE,oCAAA;ADiWd;AC1VY;EACE,oCAAA;AD4Vd;ACxVU;EACE,kCFp/DM;EEq/DN,iBAAA;AD0VZ;ACtVY;EACE,cAAA;ADwVd;AClVU;EACE,cAAA;ADoVZ;ACjVU;EACE,iBAAA;ADmVZ;ACnUY;EACE,oCAAA;ADqUd;ACjUU;EACE,kCF7hEG;EE8hEH,iBAAA;ADmUZ;ACjUY;EACE,cAAA;ADmUd;AC/TU;EACE,mCFriEI;EEsiEJ,iBAAA;ADiUZ;AC/TY;EACE,cAAA;ADiUd;AC7TU;EACE,kCF7iEM;EE8iEN,iBAAA;AD+TZ;AC7TY;EACE,cAAA;AD+Td;ACzTU;EACE,kCF3jEI;EE4jEJ,iBAAA;AD2TZ;ACzTY;EACE,oCAAA;AD2Td;ACxTY;EACE,cAAA;AD0Td;ACrTY;EACE,oCAAA;ADuTd;ACnTU;EACE,mCF5kEI;EE6kEJ,iBAAA;ADqTZ;ACjTY;EACE,cAAA;ADmTd;AC/SU;EACE,kCFtlEM;EEulEN,iBAAA;ADiTZ;AC7SY;EACE,cAAA;AD+Sd;ACxSY;EACE,oCAAA;AD0Sd;ACtSU;EACE,kCF3mEG;EE4mEH,iBAAA;ADwSZ;ACtSY;EACE,cAAA;ADwSd;ACpSU;EACE,mCFnnEI;EEonEJ,iBAAA;ADsSZ;ACpSY;EACE,oCAAA;ADsSd;ACnSY;EACE,cAAA;ADqSd;AC/RM;EACE,WAAA;EACA,eAAA;EACA,mBFhnEc;EEinEd,kBAAA;EACA,eAAA;EACA,kBAAA;ADiSR;AC/RQ;EACE,WAAA;EACA,kBAAA;EACA,sCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBF5nEY;EE6nEZ,WAAA;EACA,sBAAA;ADiSV;AC7RU;EACE,kCFzpEI;ACw7EhB;AC1RU;EACE,kCF9pEG;AC07Ef;ACvRU;EACE,mCFnqEI;AC47EhB;ACpRU;EACE,kCFxqEM;AC87ElB;AClRQ;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBF/pEY;EEgqEZ,WAAA;EACA,aAAA;ADoRV;AClRU;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,yCAAA;ADoRZ;AChRY;EACE,aAAA;ADkRd;AC/QY;EACE,gBAAA;ADiRd;AC7QU;;EAEE,eAAA;AD+QZ;AC5QU;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;AD8QZ;AC5QY;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,sBF7rEH;EE8rEG,kBAAA;AD8Qd;AC1QU;;EAEE,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AD4QZ;AC1QY;;EACE,kBAAA;AD6Qd;ACvQM;EACE,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBF7uEa;EE8uEb,cAAA;EACA,aAAA;ADyQR;ACvQQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,yCAAA;ADyQV;ACrQU;EACE,aAAA;ADuQZ;ACpQU;EACE,gBAAA;ADsQZ;AClQQ;;EAEE,eAAA;ADoQV;ACjQQ;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;ADmQV;ACjQU;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,sBFpwED;EEqwEC,kBAAA;ADmQZ;AC/PQ;;EAEE,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;ADiQV;AC/PU;;EACE,kBAAA;ADkQZ;AC1PI;EACE,8BAAA;EACA,yBFxyEgB;EEyyEhB,iBAAA;AD4PN;AC1PM;EACE,gBAAA;AD4PR;ACzPM;EACE,eAAA;EACA,gBAAA;EACA,cF1zEa;ACqjFrB;ACvPI;EACE,gBAAA;EACA,aAAA;EACA,sDAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;ADyPN;ACvPM;EAVF;IAWI,gBAAA;ED0PN;AACF;ACxPM;EAdF;IAeI,gBAAA;IACA,aAAA;ED2PN;AACF;ACxPI;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AD0PN;ACxPM;EACE,gBAAA;AD0PR;ACvPM;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;ADyPR;ACvPQ;EACE,mBAAA;ADyPV;ACnPU;EACE,kCFx3EI;AC6mFhB;AC9OU;EACE,kCF/3EG;AC+mFf;ACzOU;EACE,mCFt4EI;ACinFhB;ACpOU;EACE,kCF74EM;ACmnFlB;AChOI;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;ADkON;AC5NM;EACE,eAAA;EACA,kBAAA;EACA,yBF34EW;ACymFnB;AC1NI;EACE,yBAAA;EACA,0BAAA;AD4NN;AC1NM;EACE,kBAAA;AD4NR;AC1NQ;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AD4NV;ACxNM;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;AD0NR;ACxNQ;EARF;IASI,aAAA;IACA,qCAAA;IACA,cAAA;ED2NR;AACF;ACzNQ;EAdF;IAeI,qCAAA;ED4NR;AACF;ACzNM;EACE,YAAA;EACA,kBAAA;AD2NR;ACzNQ;EAJF;IAKI,WAAA;ED4NR;AACF;AC1NQ;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;AD4NV;AC1NU;EACE,mBAAA;AD4NZ;ACvNM;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;ADyNR;ACvNQ;EACE,eAAA;EACA,yBFv9EW;EEw9EX,kBAAA;ADyNV;ACrNU;EACE,kCF3+EI;ACksFhB;AClNU;EACE,kCFh/EG;ACosFf;AC/MU;EACE,mCFr/EI;ACssFhB;AC5MU;EACE,kCF1/EM;ACwsFlB;ACzMM;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;AD2MR;ACzMQ;EACE,eAAA;EACA,gBAAA;EACA,cF5/EW;ACusFrB;ACpMI;EACE,8BAAA;EACA,yBF7/EgB;EE8/EhB,iBAAA;ADsMN;ACpMM;EACE,eAAA;EACA,gBAAA;EACA,cF3gFa;ACitFrB;AClMI;EACE,8BAAA;EACA,yBAAA;ADoMN;AChMM;EACE,UAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,gCAAA;ADkMR;AChMQ;EACE,gBAAA;ADkMV;AChMU;EAHF;IAII,WAAA;EDmMV;AACF;AChMQ;EACE;IACE,+BAAA;EDkMV;AACF;AC9LM;EACE,cF5iFa;EE6iFb,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;ADgMR;AC9LQ;EAbF;IAcI,WAAA;EDiMR;AACF;AC/LQ;EACE,gBAAA;ADiMV;AC/LU;EACE,UAAA;ADiMZ;AC7LQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,mCFtlFM;EEulFN,WAAA;EACA,UAAA;AD+LV;AC1LI;EACE,kBAAA;AD4LN;AC1LM;EACE,mBAAA;AD4LR;ACzLM;;EAEE,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AD2LR;ACzLQ;;EACE,aAAA;AD4LV;ACxLM;EACE,YAAA;AD0LR;ACvLM;EACE,kBAAA;EACA,6BFxnFQ;EEynFR,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;ADyLR;ACvLQ;EACE,yBFxnFW;ACizFrB;;AClLA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cFvnFU;EEwnFV,cAAA;EACA,mBF7nFoB;ACkzFtB;ACnLE;EACE,sBFnnFO;ACwyFX;;ACjLA;EACE,yBFloFiB;ACszFnB;AClLE;;EAEE,cFjpFiB;ACq0FrB;;AC/KA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,gDAAA;ADkLF;AChLE;EACE,aAAA;ADkLJ;AC/KE;EACE,yBF/pFkB;EEgqFlB,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cF5qFiB;EE6qFjB,kBAAA;ADiLJ;AC/KI;EACE,mBAAA;ADiLN;AC7KE;EACE,oBAAA;AD+KJ;AC7KI;EACE,mBAAA;AD+KN;AC5KI;EACE,gBAAA;EACA,eAAA;EACA,aAAA;AD8KN;AC5KM;EACE,kBAAA;AD8KR;AC1KI;EACE,SAAA;EACA,UAAA;EACA,gBAAA;AD4KN;ACzKI;;EAEE,gBAAA;EACA,eAAA;AD2KN;ACzKM;;EACE,mBAAA;AD4KR;ACvKE;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;ADyKJ;ACvKI;EAEE,mCFnvFU;AC25FhB;ACrKI;EACE,kBAAA;EACA,QAAA;EACA,wBAAA;ADuKN;ACrKM;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBFtvFa;EEuvFb,yBAAA;ADsKR;ACnKM;EACE,4BAAA;EACA,0BAAA;ADqKR;AClKM;EACE,yBAAA;EACA,6BAAA;ADoKR;;AC9JA;EACE,yBAAA;ADiKF;AC/JE;EACE,yBAAA;ADiKJ;;AC7JA;EACE,0BAAA;ADgKF;;ACzJA;EACE,cAAA;EAKA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;ADwJF;;ACrJA;EACE,SAAA;ADwJF;;AA79FA;EACI,yBD2Ce;ACq7FnB;AA99FI;EACI,cDyCI;ECxCJ,iBAAA;AAg+FR;AA79FI;EACI,YAAA;AA+9FR;;AA39FA;EACI,0BAAA;AA89FJ;;AA39FA;EACI,SAAA;AA89FJ;;AA39FA;EACI,wBAAA;AA89FJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../../assets/styles/variables';\n@import './../teams.component.scss';\n\n.prt_view {\n    background-color: $color-light-grey;\n\n    h3 {\n        color: $color-red;\n        font-weight: bold;\n    }\n\n    .userProfile__team__accord_header {\n        z-index: 999;\n    }\n}\n\n.caps {\n    text-transform: capitalize;\n}\n\n.gap30 {\n    gap: 30px;\n}\n\n.teams__plan {\n    border-top: 0 !important;\n}","@import \"./../../../assets/styles/variables\";\n$border-color: #e7eaec;\n\n::ng-deep #holder > li {\n  padding: 5px;\n  margin: 2px;\n  display: inline-block;\n  border-color: #ddd;\n}\n\n::ng-deep #holder > li[data-page] {\n  border: solid #a0a0a0 1px;\n  border-radius: 5px;\n}\n\n::ng-deep #holder > li.separator:before {\n  content: \"...\";\n}\n\n::ng-deep #holder > li.active {\n  background-color: #f4f4f4;\n  color: inherit;\n}\n\n::ng-deep #holder > li[data-page]:hover {\n  cursor: pointer;\n}\n\n.groups {\n  margin-left: 15px;\n  margin-bottom: 10px;\n}\n\n.reset-input {\n  th {\n    position: relative;\n\n    input[type=\"search\"] {\n      width: 100% !important;\n    }\n\n    .reset-close {\n      display: none;\n      position: absolute;\n      top: 0;\n      right: 25px;\n      bottom: 0;\n      margin: auto;\n      border-radius: 50%;\n      background: #ddd;\n      border: none !important;\n      text-align: center;\n      font-size: 14px;\n      padding: 0px !important;\n      height: 16px !important;\n      width: 16px !important;\n      color: $color-light-type;\n      line-height: 1.2 !important;\n      font-family: Arial !important;\n      transform: rotate(45deg) !important;\n      -webkit-transform: rotate(45deg) !important;\n    }\n\n    &:hover {\n      .reset-close {\n        display: block;\n      }\n    }\n  }\n}\n\n.tva {\n  &__head {\n    min-height: 84px;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    border: 1px solid $border-color;\n    border-radius: 4px;\n    margin-inline: 15px;\n    padding: 17px 35px;\n\n    i:hover {\n      color: $develop-color;\n    }\n\n    @media #{$mobile} {\n      padding-inline: 20px;\n    }\n\n    &--border-0 {\n      border: 0;\n    }\n\n    &--type-1 {\n      padding: 8px 27px;\n      min-height: auto;\n\n      @media #{$mobile} {\n        padding-inline: 20px;\n      }\n\n      .tva__cta__hd {\n        h5 {\n          font-size: 16px;\n          font-weight: 700;\n        }\n      }\n    }\n\n    &--brb-0 {\n      border-bottom-right-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n\n    .f-m-bottom-0 + span {\n      font-weight: bold;\n      font-size: 12px;\n\n      img {\n        width: 40px;\n        margin-left: 6px;\n      }\n    }\n  }\n\n  &__cta {\n    &__hd {\n      width: 100%;\n\n      h5 {\n        font-size: 24px;\n        font-weight: 700;\n        color: $body-content-color;\n        margin-top: 0;\n\n        &.tva__head_subtitle {\n          font-size: 16px;\n        }\n      }\n\n      small {\n        font-size: 14px;\n      }\n    }\n\n    &__btn {\n      display: inline-block;\n\n      &--comp {\n        a {\n          background-color: transparent;\n          padding: 0;\n          color: $body-content-color;\n          border-color: $border-color;\n\n          span {\n            display: inline-block;\n            padding: 5px 12px;\n\n            &:first-child {\n              border-right: 1px solid $border-color;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &__bot {\n    table {\n      border: 1px solid $border-color;\n      border-collapse: collapse;\n\n      thead {\n        tr {\n          &:first-child {\n            background-color: $color-neutral-light;\n          }\n\n          input[type=\"checkbox\"] {\n            border: 1px solid $border-color;\n          }\n\n          th {\n            border: 0;\n          }\n        }\n      }\n\n      input[type=\"checkbox\"] {\n        display: none;\n\n        & + label {\n          position: relative;\n          cursor: pointer;\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            left: 0;\n            height: 10px;\n            width: 10px;\n            border: 1px solid $border-color;\n            border-radius: 3px;\n          }\n        }\n\n        &:checked + label::after {\n          content: \"\";\n          position: absolute;\n          left: 4px;\n          top: 3px;\n          border-right: 2px solid #e7eaec;\n          border-bottom: 2px solid #e7eaec;\n          rotate: 45deg;\n          height: 4px;\n          width: 2px;\n        }\n      }\n    }\n  }\n}\n\n.back {\n  background-color: #fff;\n  color: $body-content-color;\n  border: 0;\n}\n\n._mb_5 {\n  margin-bottom: 5px;\n}\n\n._bg_neutral_light {\n  background-color: $color-neutral-light;\n}\n\n._color_body_content {\n  color: $body-content-color;\n}\n\n.lead {\n  font-size: 8px;\n  font-weight: 700;\n  display: inline-block;\n  padding: 2px 4px;\n  background-color: $body-content-color;\n  border-radius: 2px;\n  color: #fff;\n\n  &--round {\n    background-color: $clrWhite !important;\n    color: $body-content-color !important;\n    border-radius: 50% !important;\n    border: 1px solid $color-grey-1 !important;\n  }\n}\n\n::ng-deep.userProfile {\n  border: 2px solid $color-neutral-light;\n  border-radius: 4px;\n  border-top: 0;\n\n  &--brt-0 {\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n  }\n\n  &--bdr-0 {\n    border: 0;\n  }\n\n  &__top-row {\n    @media #{$pc} {\n      & > div {\n        width: 100%;\n      }\n    }\n  }\n\n  &__team {\n    padding-inline: 8px;\n\n    &__accord {\n      border: 1px solid $color-grey-1;\n      border-radius: 4px;\n      border-top: 0;\n      min-height: 100%;\n\n      &--zindex {\n        position: relative;\n        z-index: 999;\n      }\n\n      &--mr {\n        margin-right: 2%;\n      }\n\n      &_header {\n        background-color: $color-neutral-light;\n        padding: 10px 19px;\n        min-height: 38px;\n        display: flex;\n        align-items: center;\n        &--posZind {\n          position: relative;\n          z-index: 999;\n        }\n\n        h5 {\n          color: $body-content-color;\n          margin-top: 0;\n          font-size: 14px;\n        }\n      }\n\n      &_body {\n        padding: 13px 18px;\n        position: relative;\n\n        & > :not(:last-child),\n        &_list > :not(:last-child) {\n          margin-bottom: 15px;\n        }\n\n        &_list:not(:last-child) {\n          margin-bottom: 7px !important;\n        }\n\n        &_list {\n          max-height: 146px;\n          overflow: hidden;\n          transition: all ease 0.5s;\n\n          &.active {\n            max-height: none;\n          }\n        }\n\n        * {\n          margin-top: 0;\n        }\n\n        a {\n          color: $body-content-color;\n        }\n\n        ul,\n        ol {\n          margin: 0 0 0 14px;\n          padding: 0;\n\n          & > :not(:last-child) {\n            margin-bottom: 10px;\n          }\n        }\n\n        h5 {\n          font-weight: 700;\n          font-size: 14px;\n        }\n\n        p,\n        li {\n          font-weight: 600;\n          font-size: 12px;\n        }\n\n        .active + .userProfile__team__accord_body_show_more_button {\n          position: static;\n          background-color: transparent;\n          padding-top: 0;\n        }\n\n        &_show_more_button {\n          text-align: center;\n          position: absolute;\n          bottom: 10px;\n          right: 0;\n          left: 0;\n          background: linear-gradient(180deg, transparent, $clrWhite);\n          padding-top: 10px;\n\n          button {\n            // color: #337ab7;\n            // font-size: 12px;\n            // border-radius: 2px;\n            // border: 1px solid $color-grey-1;\n            // background: #fff;\n            // padding: 4px 16px;\n            // font-family: $font-stack;\n            // font-weight: 600;\n            // cursor: pointer;\n\n            // &:hover {\n            //   color: #fff;\n            //   background-color: #337ab7;\n            //   border-color: #337ab7;\n            // }\n          }\n        }\n\n        &_exter_links {\n          & > :not(:last-child) {\n            border-bottom: 1px solid $color-grey-1;\n            margin-bottom: 4px;\n            padding-bottom: 7px;\n          }\n\n          @media #{$mobile} {\n            & > div > div {\n              flex: none;\n              width: 100%;\n              text-align: left;\n            }\n          }\n\n          a {\n            &:hover i {\n              color: $develop-color;\n            }\n\n            i {\n              transition: 300ms;\n            }\n          }\n        }\n\n        &_groups {\n          display: grid;\n          grid-template-columns: repeat(4, 1fr);\n          grid-gap: 20px;\n\n          @media #{$pc} {\n            grid-template-columns: repeat(2, 1fr);\n          }\n\n          .clarify {\n            .userProfile__team__accord_body_groups_header {\n              background-color: $clarify-color;\n            }\n\n            h5 {\n              color: $body-content-color;\n              font-weight: 600;\n\n              span {\n                color: $clarify-color;\n              }\n            }\n          }\n\n          .ideate {\n            .userProfile__team__accord_body_groups_header {\n              background-color: $ideate-color;\n            }\n\n            h5 {\n              color: $body-content-color;\n              font-weight: 600;\n\n              span {\n                color: $ideate-color;\n              }\n            }\n          }\n\n          .develop {\n            .userProfile__team__accord_body_groups_header {\n              background-color: $develop-color;\n            }\n\n            h5 {\n              color: $body-content-color;\n              font-weight: 600;\n\n              span {\n                color: $develop-color;\n              }\n            }\n          }\n\n          .implement {\n            .userProfile__team__accord_body_groups_header {\n              background-color: $implement-color;\n            }\n\n            h5 {\n              color: $body-content-color;\n              font-weight: 600;\n\n              span {\n                color: $implement-color;\n              }\n            }\n          }\n\n          &_header {\n            padding: 6px 10px;\n            border-radius: 2px;\n            background-color: var(--group_clr);\n            font-size: 14px;\n            font-weight: 600;\n            color: #fff;\n\n            &:not(:last-child) {\n              margin-bottom: 15px;\n            }\n          }\n\n          h5 {\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n            grid-gap: 3px;\n\n            &:not(:last-child) {\n              margin-bottom: 5px;\n            }\n\n            span {\n              width: 18px;\n              display: inline-flex;\n              justify-content: center;\n              align-items: center;\n              aspect-ratio: 1;\n              border-radius: 50%;\n              background: $color-neutral-light;\n              font-size: 0.8em;\n            }\n          }\n\n          ul {\n            margin: 0;\n            padding: 0;\n            list-style: none;\n\n            &:not(:last-child) {\n              margin-bottom: 15px;\n            }\n\n            li:not(:last-child) {\n              margin-bottom: 3px;\n            }\n          }\n        }\n      }\n    }\n    &__spcltxt {\n      font-size: 12px;\n      padding: 10px 16px;\n      font-style: italic;\n    }\n  }\n\n  &__graph {\n    .wrapper-content {\n      &--pd-0 {\n        padding: 0;\n      }\n    }\n\n    &_header {\n      background-color: $color-neutral-light;\n      padding: 9px 17px;\n      font-size: 14px;\n      font-weight: 700;\n      color: $body-content-color;\n      border-radius: 5px 5px 0 0;\n\n      span {\n        font-weight: 600;\n\n        .tooltip-text {\n          display: none;\n        }\n\n        &.info-text {\n          position: relative;\n\n          &:hover {\n            cursor: pointer;\n\n            .tooltip-text {\n              display: none;\n              position: absolute;\n              display: inline-block;\n              min-width: 240px;\n              bottom: calc(100% + 10px);\n              background-color: #fff;\n              left: 50%;\n              transform: translateX(-50%);\n              padding: 5px;\n              border-radius: 4px;\n              text-align: center;\n              z-index: 99;\n\n              &::before {\n                content: \"\";\n                width: 16px;\n                height: 8px;\n                clip-path: polygon(0 0, 100% 0, 50% 100%);\n                background-color: $clrWhite;\n                position: absolute;\n                top: 99%;\n                left: 50%;\n                transform: translateX(-50%);\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &__plan {\n      width: 85%;\n      margin-left: auto;\n      h5 {\n        font-size: 14px;\n        font-weight: 600;\n        border-bottom: 1px solid $color-grey-1;\n        padding-bottom: 10px;\n        margin: 0;\n      }\n\n      &-pf {\n        color: $body-content-color;\n        opacity: 0.6;\n\n        .teams__profile_inner {\n          padding-inline: 5px;\n          border-right: 1px solid $color-grey-1;\n\n          &:last-child {\n            border-right: 0;\n          }\n\n          .nobg {\n            background-color: transparent !important;\n            font-weight: 400 !important;\n          }\n        }\n      }\n\n      &--our {\n        position: relative;\n        z-index: 999;\n\n        h5 {\n          padding-bottom: 0;\n          border: 0;\n        }\n\n        textarea {\n          border: 1px solid $border-color;\n        }\n\n        .cross_icn {\n          width: 22px;\n          height: 22px;\n          border: 1px solid #e7eaec;\n          position: relative;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          margin-right: 5px;\n        }\n\n        .cancel_btn {\n          color: $body-content-color;\n          border: 0;\n          font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial,\n            sans-serif;\n          font-size: 14px;\n          font-weight: 700;\n          transition: all ease 0.3s;\n          padding-right: 7px;\n        }\n\n        .save_btn {\n          display: inline-block;\n          font-size: 10px;\n          font-weight: bold;\n          border: 1px solid #e7eaec;\n          border-radius: 20px;\n          padding: 3px 6px;\n        }\n      }\n    }\n\n    &__lead {\n      width: 87%;\n      margin-left: auto;\n    }\n  }\n\n  .team-compo {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    grid-gap: 30px;\n\n    .profile-section {\n      margin-bottom: 0;\n      flex: 1.2;\n    }\n\n    .below-chart {\n      flex: 1;\n      box-shadow: none;\n      border-radius: 4px;\n\n      @media #{$tablet} {\n        flex: auto;\n      }\n    }\n  }\n\n  .team-graph .chart-container {\n    max-width: 100% !important;\n  }\n}\n\n.teams {\n  &_cont {\n    &--mxwd {\n      max-width: 357px;\n    }\n  }\n\n  &__row-autofit {\n    display: grid;\n    margin: 0;\n    grid-template-columns: repeat(auto-fit, minmax(0, 230px));\n    grid-gap: calc(2 * var(--gap-default));\n\n    @media #{$mobile} {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__col-autofit {\n    width: 100% !important;\n    padding-inline: 0;\n  }\n\n  &--b-e {\n    border: 2px solid $color-neutral-light;\n    border-radius: 4px;\n  }\n\n  &--brt-0 {\n    border-top-right-radius: 0;\n    border-top-left-radius: 0;\n  }\n\n  &__col-4 {\n    @media #{$desktop} {\n      width: 50%;\n    }\n\n    @media #{$pc} {\n      width: 100%;\n    }\n  }\n\n  &__col-6 {\n    @media #{$pc} {\n      width: 100%;\n    }\n  }\n\n  &__cell {\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    @media #{$mobile} {\n      margin-right: 0;\n    }\n\n    &:hover {\n      .teams__header_btn {\n        opacity: 1;\n        background-color: $develop-color;\n      }\n    }\n  }\n\n  &__header {\n    background-color: $color-neutral-light;\n    padding: 9px 15px 9px 18px;\n    border-radius: 5px 5px 0 0;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    grid-gap: 10px;\n\n    &--wbg {\n      background-color: $clrWhite;\n    }\n\n    &--bdr {\n      border: 1px solid $color-grey-1;\n    }\n\n    &_title {\n      font-size: 12px;\n      font-family: $font-stack;\n      color: $body-content-color;\n      font-weight: 700;\n      flex: 1;\n\n      &--capsbrk {\n        text-transform: capitalize;\n        word-break: break-all;\n      }\n\n      .tm_name {\n        &:hover {\n          .short_name {\n            display: none;\n          }\n          .full_name {\n            display: inline-block;\n          }\n        }\n\n        .full_name {\n          display: none;\n        }\n      }\n\n      &__contr {\n        gap: 10px;\n\n        .roster {\n          color: #fff;\n          background-color: $body-content-color;\n          border: 1px solid $color-light-grey;\n          border-radius: 50%;\n          width: 20px;\n          height: 20px;\n          text-align: center;\n          font-size: 10px;\n          padding-top: 1px;\n\n          &__name {\n            display: none;\n            width: 150px;\n            color: #676a6c;\n            background-color: #fff;\n            text-align: center;\n            border-radius: 6px;\n            padding: 6px;\n            box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n            font-size: 13px;\n            font-family: \"Open Sans\", sans-serif;\n            line-height: 1.5;\n            position: absolute;\n            top: -35px;\n            left: -16px;\n            z-index: 1;\n          }\n\n          &:hover {\n            .roster__name {\n              display: block;\n            }\n          }\n        }\n      }\n    }\n\n    &_btn {\n      background-color: $color-light-grey;\n      color: $clrWhite;\n      font-weight: 700;\n      opacity: 0.6;\n      font-size: 10px;\n    }\n\n    button {\n      background-color: $clrWhite;\n      border-radius: 2px;\n      padding: 4px 9px;\n      font-size: 8px;\n      font-weight: 700;\n      color: $body-content-color;\n      font-family: $font-stack;\n      padding: 4px 9px;\n    }\n\n    .disable {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n\n  &__profile {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    grid-gap: 10px 20px;\n    padding: 13px 19px 10px;\n\n    &--pd {\n      padding-top: 20px;\n      padding-bottom: 0;\n      min-height: 46px;\n    }\n\n    &--bdrtop {\n      border-top: 1px solid $color-grey-1;\n    }\n\n    &--nflx {\n      display: block;\n      padding: 13px 9px 10px;\n    }\n\n    &_inner {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      grid-gap: 10px;\n\n      &__pfn {\n        line-height: 1;\n      }\n\n      .nobg {\n        background-color: #fff;\n        font-weight: normal;\n        padding: 0;\n        display: inline-block;\n      }\n\n      &--rytbdr {\n        border-right: 1px solid $color-grey-1;\n\n        &:last-child {\n          border-right: 0;\n        }\n      }\n\n      ::ng-deep .profile_types {\n        margin-left: 0;\n      }\n\n      &--gap5 {\n        grid-gap: 5px;\n\n        .trans_scale {\n          transform: scale(0.8);\n        }\n      }\n\n      span {\n        display: inline-block;\n        background-color: #d4d4d4;\n        color: #676a6c;\n        padding: 4px;\n        font-size: 10px;\n        border-radius: 2px;\n        font-weight: 700;\n        text-align: center;\n\n        &.txt {\n          background-color: transparent;\n          display: block;\n          padding: 0;\n          text-align: left;\n          font-weight: 400;\n        }\n      }\n\n      @media #{$tablet} {\n        width: 100%;\n      }\n\n      &--usrPf {\n        width: 90%;\n        margin-left: auto;\n        padding-top: 11px;\n      }\n    }\n\n    img {\n      margin-right: 5px;\n      width: 35px;\n    }\n\n    &_name {\n      color: $body-content-color;\n      font-size: 12px;\n      font-weight: 700;\n    }\n\n    span.lead {\n      @extend .lead;\n\n      @media #{$tablet} {\n        margin-left: auto;\n      }\n    }\n  }\n\n  &__tab_table {\n    padding: 20px;\n\n    ::ng-deep table {\n      padding: 0;\n      border: 1px solid $color-grey-1;\n      border-collapse: collapse;\n      min-width: 450px;\n\n      th,\n      td {\n        border: 1px solid $color-grey-1 !important;\n        padding: 5px;\n        font-size: 12px;\n\n        &:not(:first-child) {\n          text-align: center;\n        }\n      }\n\n      td {\n        font-weight: 600;\n      }\n\n      .records_select {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        grid-gap: 5px;\n        margin-bottom: 0;\n\n        label {\n          margin-bottom: 0;\n        }\n      }\n\n      select {\n        width: min(70px, 100%);\n\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n  }\n\n  &__tab_content {\n    padding: 20px;\n\n    ::ng-deep .team-tls {\n      padding: 0;\n\n      &__inner {\n        padding-inline: 0;\n\n        &:not(:last-child) {\n          margin-bottom: 10px;\n        }\n\n        * {\n          font-size: 12px;\n          font-weight: 600;\n        }\n      }\n\n      ul {\n        margin: 0;\n        padding: 0 0 0 24px;\n\n        li:not(:last-child) {\n          margin-bottom: 5px;\n        }\n      }\n    }\n  }\n\n  .title-case.role {\n    span {\n      @extend .lead;\n    }\n  }\n\n  ::ng-deep &__buttons {\n    display: flex;\n    flex-wrap: wrap;\n    border-top: 1px solid $color-grey-1;\n    border-bottom: 1px solid $color-grey-1;\n\n    button {\n      flex: 1;\n      border: 0;\n      color: $body-content-color;\n      text-align: center;\n      font-size: 10px;\n      font-weight: 600;\n      padding: 12px;\n      background-color: transparent;\n      cursor: pointer;\n      position: relative;\n\n      &:hover {\n        background-color: $color-grey-1;\n\n        &::after {\n          // opacity: 1;\n        }\n      }\n\n      &.active::after {\n        content: \"\";\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        height: 2px;\n        background-color: $low-develop-color;\n        opacity: 1;\n      }\n\n      &:not(:last-child) {\n        border-right: 1px solid $color-grey-1;\n      }\n    }\n  }\n\n  .profile_types.no-profile {\n    background-image: none !important;\n    width: auto;\n\n    &::after {\n      color: $body-content-color;\n      background-color: $color-light-grey;\n      content: \"No profile\";\n      padding: 5px 8px;\n      font-size: 10px;\n      left: -10px;\n      position: relative;\n      top: -6px;\n    }\n  }\n\n  ::ng-deep .team-graph {\n    &--wd {\n      width: 80%;\n    }\n\n    &--ma {\n      margin: 0 auto;\n    }\n\n    &--mva {\n      margin: auto 0;\n    }\n\n    &.wrapper-content {\n      padding: 16px 16px 0;\n      margin-bottom: 11px;\n    }\n  }\n\n  &__plan {\n    z-index: 99;\n    border-top: 1px solid $color-grey-1;\n\n    h5 {\n      font-size: 14px;\n      font-weight: 600;\n    }\n\n    p {\n      font-size: 12px;\n      opacity: 0.6;\n    }\n\n    textarea {\n      border: 1px solid $color-grey-1;\n      width: 100%;\n      padding: 10px;\n      resize: vertical;\n      font-size: 10px;\n\n      &:focus {\n        outline: none;\n        // font-size: 12px;\n      }\n    }\n\n    &--wd {\n      max-width: 85%;\n      margin-left: auto;\n    }\n\n    &--pdt {\n      padding-top: 36px;\n    }\n\n    &--bdr {\n      border: 1px solid $color-grey-1;\n      border-top: 0;\n      padding-inline: 10px;\n    }\n\n    &__my {\n      // border-bottom: 1px solid $color-grey-1;\n\n      &:not(:last-child) {\n        padding-bottom: 12px;\n      }\n\n      i {\n        font-size: 10px !important;\n      }\n\n      h5 {\n        margin: 0;\n        font-size: 10px;\n      }\n\n      .save_btn {\n        display: inline-block;\n        font-size: 10px;\n        font-weight: bold;\n        border: 1px solid $color-grey-1;\n        border-radius: 20px;\n        padding: 3px 6px;\n      }\n\n      .cross_icn {\n        width: 22px;\n        height: 22px;\n        border: 1px solid $color-grey-1;\n        position: relative;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-right: 5px;\n      }\n\n      .cancel_btn {\n        color: $body-content-color;\n        border: 0;\n        font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n        font-size: 14px;\n        font-weight: 700;\n        transition: all ease 0.3s;\n        padding-right: 7px;\n      }\n\n      &--bdr {\n        border-bottom: 1px solid $color-grey-1;\n      }\n\n      &--indiv {\n        h5,\n        i {\n          font-size: 14px !important;\n        }\n\n        textarea {\n          font-size: 12px;\n        }\n      }\n    }\n\n    &__our {\n      padding-bottom: 10px;\n    }\n\n    &__svd {\n      border: 1px solid $color-grey-1;\n      padding: 10px 5px;\n      border-radius: 5px;\n    }\n  }\n\n  &__body {\n    border: 1px solid $color-grey-1;\n    border-top: 0;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n\n    &--nobdr {\n      border: 0;\n    }\n  }\n\n  .team-table {\n    padding: 10px;\n\n    &-bg {\n      ::ng-deep .hide-ratio {\n        h5 {\n          display: none;\n        }\n      }\n\n      ::ng-deep .show-counter {\n        display: flex;\n        justify-content: center;\n\n        &.high-clarify,\n        &.low-clarify {\n          h5 {\n            border: 5px solid $clarify-color;\n            background-color: $clarify-color;\n            color: $clarify-color !important;\n            text-shadow: none !important;\n          }\n        }\n\n        &.high-ideate,\n        &.low-ideate {\n          h5 {\n            border: 5px solid $ideate-color;\n            background-color: $ideate-color;\n            color: $ideate-color !important;\n            text-shadow: none !important;\n          }\n        }\n\n        &.high-develop,\n        &.low-develop {\n          h5 {\n            border: 5px solid $develop-color;\n            background-color: $develop-color;\n            color: $develop-color !important;\n            text-shadow: none !important;\n          }\n        }\n\n        &.high-implement,\n        &.low-implement {\n          h5 {\n            border: 5px solid $implement-color;\n            background-color: $implement-color;\n            color: $implement-color !important;\n            text-shadow: none !important;\n          }\n        }\n\n        h5 {\n          height: 30px !important;\n          width: 30px !important;\n          border-radius: 50%;\n          margin-inline: auto;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          margin-bottom: 10px !important;\n          @media screen and (max-width: 480px) {\n            height: 20px !important;\n            width: 20px !important;\n          }\n        }\n      }\n\n      ::ng-deep .high-clarify.common-high.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .high-ideate.common-high.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .high-develop.common-high.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .high-implement.common-high.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .low-clarify.common-low.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .low-ideate.common-low.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .low-develop.common-low.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n\n      ::ng-deep .low-implement.common-low.common-profile._bg_changer {\n        background-color: $color-light-grey !important;\n      }\n    }\n\n    img {\n      width: 17%;\n    }\n\n    table {\n      border: 2px solid $color-neutral-light;\n      border-right: 0;\n\n      thead {\n        background-color: $color-grey-1;\n        padding: 7px;\n        font-size: 12px;\n      }\n\n      tbody {\n        tr {\n          td {\n            width: calc(100% / 3);\n            border-right: 2px solid $color-neutral-light;\n            padding: 7px;\n          }\n        }\n      }\n    }\n  }\n\n  ::ng-deep.ibox {\n    border: 0;\n\n    &-title {\n      border-top: 0;\n      padding: 8px 18px;\n      min-height: auto;\n      background-color: $color-neutral-light;\n      border-radius: 4px 4px 0 0;\n\n      h5 {\n        float: none;\n        font-size: 12px;\n        font-weight: 700;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n\n      &--fx {\n        h5 {\n          display: flex;\n        }\n      }\n    }\n\n    &-content {\n      padding: 0;\n      border: 1px solid $color-grey-1;\n      border-radius: 0 0 4px 4px;\n\n      table {\n        margin-bottom: 0;\n\n        th {\n          font-size: 10px;\n          color: $body-content-color;\n\n          .soryby_outer {\n            display: inline-flex;\n            flex-direction: column;\n            height: 12px;\n            line-height: 1;\n            position: relative;\n            width: 10px;\n            top: 2px;\n\n            & > div {\n              position: absolute;\n              left: 50%;\n              transform: translateX(-50%);\n\n              &:nth-child(1) {\n                top: 0;\n              }\n\n              &:nth-child(2) {\n                bottom: 0;\n              }\n            }\n          }\n        }\n\n        td {\n          color: $body-content-color;\n\n          &.title-case {\n            span {\n              border-radius: 2px;\n              background-color: $body-content-color;\n              color: $clrWhite;\n              padding: 2px 4px 3px;\n              font-size: 10px;\n              font-weight: 700;\n            }\n          }\n\n          &.one_one_adv {\n            a {\n              display: inline-block;\n              border: 2px solid $develop-color;\n              color: $develop-color;\n              font-weight: 700;\n              padding: 4px 10px;\n              border-radius: 4px;\n              font-size: clamp(10px, 1vw, 14px);\n              text-align: center;\n              min-width: 100px;\n\n              &:hover {\n                background-color: $develop-color;\n                color: $clrWhite;\n              }\n            }\n          }\n\n          a {\n            color: inherit;\n          }\n\n          .no_pf {\n            display: inline-block;\n            background-color: #d4d4d4;\n            color: $body-content-color;\n            padding: 4px;\n            font-size: 10px;\n            border-radius: 2px;\n            font-weight: 700;\n            text-align: center;\n          }\n        }\n\n        .records_select {\n          display: flex;\n          flex-wrap: wrap;\n          align-items: center;\n          grid-gap: 5px;\n          margin-bottom: 0;\n\n          label {\n            margin-bottom: 0;\n          }\n\n          select {\n            width: min(70px, 100%);\n          }\n        }\n      }\n    }\n  }\n}\n\n::ng-deep .for-team-compo {\n  display: none;\n}\n\n.f-m-inline-0 {\n  margin-inline: 0 !important;\n}\n@media screen and (max-width: 1024px) {\n  .f-col-sm-12 {\n    width: 100%;\n  }\n}\nspan.sortby {\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: 99999;\n  text-align: right;\n  position: absolute;\n  padding-right: 14px;\n}\n\n.art_dropdown_right {\n  .circle__dropdown {\n    right: 0;\n    left: auto;\n\n    &::after {\n      right: 17%;\n      left: auto;\n    }\n  }\n}\n\n.art_dropdown_bottom {\n  .circle__dropdown {\n    top: calc(100% + 10px);\n    right: 0;\n    bottom: auto;\n    left: auto;\n\n    &::after {\n      top: auto;\n      right: 17%;\n      bottom: 99%;\n      left: auto;\n      clip-path: polygon(50% 0, 100% 100%, 0 100%);\n    }\n  }\n}\n\n::ng-deep.team_meet {\n  padding-block: 29px;\n  &--pd {\n    padding-left: 3%;\n    padding-right: 7%;\n  }\n\n  & > *:not(:last-child) {\n    margin-bottom: 42px;\n  }\n\n  &__block {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n\n    @media #{$pc} {\n      grid-template-columns: 1fr;\n      grid-row-gap: 30px;\n    }\n  }\n\n  &__col {\n    padding: 49px 35px;\n\n    @media #{$mobile} {\n      padding: 15px;\n    }\n\n    & > :not(:last-child) {\n      margin-bottom: 22px;\n    }\n\n    &--left {\n      border-radius: 4px 0px 0px 4px;\n      background-color: $color-neutral-light;\n\n      @media #{$mobile} {\n        border-radius: 4px;\n      }\n    }\n\n    &--right {\n      border-radius: 0px 4px 4px 0px;\n      border: 1px solid $color-grey-1;\n\n      @media #{$mobile} {\n        border-radius: 4px;\n      }\n\n      .team_meet__col_art {\n        border: 1px solid $color-grey-1;\n      }\n    }\n\n    &_header {\n      display: flex;\n      flex-wrap: wrap;\n      grid-gap: 20px;\n\n      &_left {\n        flex: 1;\n\n        h2 {\n          font-size: 24px;\n          font-weight: 700;\n          color: $body-content-color;\n\n          span {\n            display: block;\n            font-size: 16px;\n            line-height: 1.5;\n          }\n        }\n      }\n\n      &_right {\n        width: 125px;\n      }\n    }\n\n    &_desc {\n      p,\n      li {\n        color: #5c5d60;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 157%;\n\n        a {\n          text-decoration: underline;\n        }\n\n        button {\n          background-color: transparent;\n          border: 0;\n          color: $anchor-color;\n          cursor: pointer;\n        }\n      }\n    }\n\n    &_art {\n      border-radius: 4px;\n      background-color: #fff;\n\n      &_header {\n        border-bottom: 1px solid $color-grey-1;\n        padding: 10px 22px;\n        color: $body-content-color;\n        font-size: 14px;\n        font-weight: 700;\n      }\n\n      &_body {\n        padding: clamp(20px, 6vw, 90px) 16px;\n        text-align: center;\n\n        img {\n          max-width: 715px;\n          width: 100%;\n          display: block;\n          margin-inline: auto;\n        }\n\n        &_wrapper {\n          max-width: 715px;\n          width: 100%;\n          margin-inline: auto;\n        }\n\n        &_inner {\n          margin-top: clamp(140px, 11vw, 150px);\n          position: relative;\n          padding-bottom: 28%;\n        }\n      }\n\n      &_grid {\n        --lineHeight: 16%;\n        --line_top_to_bottom: rotate(30deg);\n        --line_bottom_to_top: rotate(-30deg);\n        display: grid;\n        grid-template-columns: repeat(4, 12%);\n        justify-content: space-between;\n        grid-gap: 20px;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 0;\n\n        &.p_id_7 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              background-color: $clarify-color;\n              display: block;\n            }\n          }\n\n          .develop {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            @extend .art_dropdown_right;\n\n            .circle__dropdown {\n              background-color: $implement-color;\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_6 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .ideate {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_1 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_3 {\n          .ideate {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_9 {\n          .clarify {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .develop {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            @extend .art_dropdown_right;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_5 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n          }\n        }\n\n        &.p_id_10 {\n          @extend .art_dropdown_right;\n\n          .ideate {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_11 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n          }\n        }\n\n        &.p_id_12 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n          }\n\n          .develop {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            @extend .art_dropdown_right;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_2 {\n          .clarify {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n          }\n        }\n\n        &.p_id_4 {\n          .develop {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            @extend .art_dropdown_right;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_14 {\n          .circle_dropdown_integrator {\n            display: block;\n          }\n\n          .circle {\n            align-self: start;\n\n            &.develop {\n              @extend .art_dropdown_bottom;\n            }\n\n            &.implement {\n              @extend .art_dropdown_right;\n            }\n          }\n        }\n\n        &.p_id_13 {\n          @extend .art_dropdown_right;\n\n          .clarify {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_15 {\n          .clarify {\n            background-color: $clarify-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .ideate {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            @extend .art_dropdown_right;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .implement {\n            background-color: $implement-color;\n            align-self: start;\n\n            @extend .art_dropdown_right;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n\n        &.p_id_8 {\n          .clarify {\n            &::before {\n              transform: var(--line_bottom_to_top);\n            }\n          }\n\n          .ideate {\n            background-color: $ideate-color;\n            align-self: start;\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n\n          .develop {\n            background-color: $develop-color;\n            align-self: start;\n\n            &::before {\n              transform: var(--line_top_to_bottom);\n            }\n\n            .circle__dropdown {\n              display: block;\n            }\n          }\n        }\n      }\n\n      .circle {\n        width: 100%;\n        aspect-ratio: 1;\n        background: $color-neutral-light;\n        border-radius: 50%;\n        align-self: end;\n        position: relative;\n\n        &:not(:last-child)::before {\n          content: \"\";\n          position: absolute;\n          top: calc(50% - (var(--lineHeight) / 2));\n          height: var(--lineHeight);\n          margin-block: auto;\n          width: 235%;\n          background: $color-neutral-light;\n          z-index: -1;\n          transform-origin: left;\n        }\n\n        &.clarify {\n          .circle__dropdown {\n            background-color: $clarify-color;\n          }\n        }\n\n        &.ideate {\n          .circle__dropdown {\n            background-color: $ideate-color;\n          }\n        }\n\n        &.develop {\n          .circle__dropdown {\n            background-color: $develop-color;\n          }\n        }\n\n        &.implement {\n          .circle__dropdown {\n            background-color: $implement-color;\n          }\n        }\n\n        &__dropdown {\n          position: absolute;\n          bottom: calc(100% + 10px);\n          padding: 7px;\n          border-radius: 5px;\n          text-align: left;\n          background: $color-neutral-light;\n          width: 230%;\n          display: none;\n\n          &::after {\n            content: \"\";\n            position: absolute;\n            top: 99%;\n            left: 15%;\n            width: 20px;\n            height: 8px;\n            background-color: inherit;\n            clip-path: polygon(0 0, 100% 0, 50% 100%);\n          }\n\n          & > * {\n            &:first-child {\n              margin-top: 0;\n            }\n\n            &:last-child {\n              margin-bottom: 0;\n            }\n          }\n\n          ul,\n          ol {\n            padding-left: 0;\n          }\n\n          li {\n            position: relative;\n            list-style: none;\n            padding-left: 8px;\n\n            &::before {\n              content: \"\";\n              position: absolute;\n              top: 50%;\n              transform: translateY(-50%);\n              left: 0;\n              width: 4px;\n              aspect-ratio: 1;\n              background-color: $clrWhite;\n              border-radius: 50%;\n            }\n          }\n\n          p,\n          li {\n            font-size: clamp(8px, 1vw, 14px);\n            line-height: 1.3;\n            font-weight: 600;\n            color: #fff;\n\n            &:not(:last-child) {\n              margin-bottom: 5px;\n            }\n          }\n        }\n      }\n\n      .circle_dropdown_integrator {\n        position: absolute;\n        bottom: calc(100% + 20px);\n        left: 50%;\n        transform: translateX(-50%);\n        padding: 7px;\n        border-radius: 5px;\n        text-align: left;\n        background: $body-content-color;\n        width: 27.597%;\n        display: none;\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          top: 99%;\n          left: 50%;\n          transform: translateX(-50%);\n          width: 20px;\n          height: 8px;\n          background-color: inherit;\n          clip-path: polygon(0 0, 100% 0, 50% 100%);\n        }\n\n        & > * {\n          &:first-child {\n            margin-top: 0;\n          }\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n\n        ul,\n        ol {\n          padding-left: 0;\n        }\n\n        li {\n          position: relative;\n          list-style: none;\n          padding-left: 8px;\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            top: 50%;\n            transform: translateY(-50%);\n            left: 0;\n            width: 4px;\n            aspect-ratio: 1;\n            background-color: $clrWhite;\n            border-radius: 50%;\n          }\n        }\n\n        p,\n        li {\n          font-size: clamp(8px, 1vw, 14px);\n          line-height: 1.3;\n          font-weight: 600;\n          color: #fff;\n\n          &:not(:last-child) {\n            margin-bottom: 5px;\n          }\n        }\n      }\n    }\n  }\n\n  &__challenges {\n    &_header {\n      border-radius: 4px 4px 0px 0px;\n      background-color: $color-neutral-light;\n      padding: 9px 22px;\n\n      & > :last-child {\n        margin-bottom: 0;\n      }\n\n      h2 {\n        font-size: 16px;\n        font-weight: 700;\n        color: $body-content-color;\n      }\n    }\n\n    &_grid {\n      --col_per_row: 4;\n      display: grid;\n      grid-template-columns: repeat(var(--col_per_row), 1fr);\n      grid-gap: 18px;\n      padding: 25px 41px;\n      border: 1px solid $color-grey-1;\n      border-top: 0;\n      border-radius: 0 0 4px 4px;\n\n      @media #{$pc} {\n        --col_per_row: 2;\n      }\n\n      @media #{$mobile} {\n        --col_per_row: 1;\n        padding: 20px;\n      }\n    }\n\n    &_col {\n      border-radius: 4px;\n      border: 1px solid $color-grey-1;\n      background-color: #fff;\n      padding: 27px 20px 30px;\n      text-align: center;\n\n      & > :last-child {\n        margin-bottom: 0;\n      }\n\n      h3 {\n        font-size: 16px;\n        text-transform: uppercase;\n        font-weight: 700;\n\n        &:not(:last-child) {\n          margin-bottom: 18px;\n        }\n      }\n\n      &.clarify {\n        .team_meet__challenges_profile {\n          div.high {\n            background-color: $clarify-color;\n          }\n        }\n      }\n\n      &.ideate {\n        .team_meet__challenges_profile {\n          div.high {\n            background-color: $ideate-color;\n          }\n        }\n      }\n\n      &.develop {\n        .team_meet__challenges_profile {\n          div.high {\n            background-color: $develop-color;\n          }\n        }\n      }\n\n      &.implement {\n        .team_meet__challenges_profile {\n          div.high {\n            background-color: $implement-color;\n          }\n        }\n      }\n    }\n\n    &_profile {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      grid-gap: 10px;\n      width: 111px;\n      margin-inline: auto;\n\n      // &:not(:last-child) {\n      //     margin-bottom: 26px;\n      // }\n\n      & > div {\n        aspect-ratio: 1;\n        border-radius: 50%;\n        background-color: $color-light-grey;\n      }\n    }\n\n    &_integrator {\n      border: 1px solid $color-grey-1;\n      border-radius: 0 0 4px 4px;\n\n      &_inner {\n        padding: 25px 41px;\n\n        & > :not(:last-child) {\n          margin-bottom: 27px;\n          padding-bottom: 27px;\n          border-bottom: 1px solid $color-grey-1;\n        }\n      }\n\n      &_grid {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        width: min(1400px, 100%);\n        margin-inline: auto;\n        grid-row-gap: 10px;\n\n        @media #{$tablet} {\n          display: grid;\n          grid-template-columns: repeat(2, 1fr);\n          grid-gap: 30px;\n        }\n\n        @media #{$mobile} {\n          grid-template-columns: repeat(1, 1fr);\n        }\n      }\n\n      &_col {\n        width: 111px;\n        text-align: center;\n\n        @media #{$tablet} {\n          width: 100%;\n        }\n\n        h3 {\n          font-size: 16px;\n          text-transform: uppercase;\n          font-weight: 700;\n\n          &:not(:last-child) {\n            margin-bottom: 16px;\n          }\n        }\n      }\n\n      &_profile {\n        display: grid;\n        grid-template-columns: repeat(2, 1fr);\n        grid-gap: 10px;\n        width: 111px;\n        margin-inline: auto;\n\n        & > div {\n          aspect-ratio: 1;\n          background-color: $body-content-color;\n          border-radius: 50%;\n        }\n\n        &.clarify {\n          div.high {\n            background-color: $clarify-color;\n          }\n        }\n\n        &.ideate {\n          div.high {\n            background-color: $ideate-color;\n          }\n        }\n\n        &.develop {\n          div.high {\n            background-color: $develop-color;\n          }\n        }\n\n        &.implement {\n          div.high {\n            background-color: $implement-color;\n          }\n        }\n      }\n\n      &_info {\n        text-align: center;\n        width: min(647px, 100%);\n        margin-inline: auto;\n\n        p {\n          font-size: 14px;\n          font-weight: 600;\n          color: $body-content-color;\n        }\n      }\n    }\n  }\n\n  &__agreement {\n    &_header {\n      border-radius: 4px 4px 0px 0px;\n      background-color: $color-neutral-light;\n      padding: 9px 22px;\n\n      h3 {\n        font-size: 16px;\n        font-weight: 700;\n        color: $body-content-color;\n      }\n    }\n\n    &_body {\n      border-radius: 0px 0px 4px 4px;\n      border: 1px solid $color-grey-1;\n    }\n\n    &_tab_nav {\n      ul {\n        padding: 0;\n        margin: 0;\n        display: flex;\n        flex-wrap: wrap;\n        border-bottom: 1px solid $color-grey-1;\n\n        li {\n          list-style: none;\n\n          @media #{$mobile} {\n            width: 100%;\n          }\n        }\n\n        @media #{$mobile-up} {\n          li:not(:last-child) {\n            border-right: 1px solid $color-grey-1;\n          }\n        }\n      }\n\n      button {\n        color: $body-content-color;\n        font-size: 12px;\n        font-weight: 600;\n        opacity: 0.9;\n        min-width: 219px;\n        border: 0;\n        background-color: transparent;\n        padding: 9px 23px;\n        position: relative;\n        border-radius: 0;\n        cursor: pointer;\n\n        @media #{$mobile} {\n          width: 100%;\n        }\n\n        &.active {\n          font-weight: 700;\n\n          &::after {\n            opacity: 1;\n          }\n        }\n\n        &::after {\n          content: \"\";\n          position: absolute;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          background-color: $develop-color;\n          height: 2px;\n          opacity: 0;\n        }\n      }\n    }\n\n    &_tab_content {\n      padding: 24px 20px;\n\n      form > *:not(:last-child) {\n        margin-bottom: 16px;\n      }\n\n      input,\n      textarea {\n        border-radius: 4px;\n        border: 1px solid $color-grey-1;\n        height: 122px;\n        resize: none;\n        padding: 11px 15px;\n        width: 100%;\n\n        &:focus {\n          outline: none;\n        }\n      }\n\n      input {\n        height: 34px;\n      }\n\n      input[type=\"submit\"] {\n        border-radius: 4px;\n        background: $develop-color;\n        font-size: 14px;\n        font-weight: 600;\n        text-align: center;\n        color: #fff;\n        border: 0;\n        width: auto;\n        padding: 7px 27px;\n        cursor: pointer;\n        transition: 0.3s;\n\n        &:hover {\n          background-color: $body-content-color;\n        }\n      }\n    }\n  }\n}\n\n::ng-deep._no_profile_ {\n  height: 18px;\n  width: 18px;\n  border-radius: 50%;\n  color: $color-red;\n  font-size: 8px;\n  background: $color-neutral-light;\n\n  &._bgw_ {\n    background-color: $clrWhite;\n  }\n}\n\n::ng-deep.missing-profiles {\n  background-color: $color-light-grey;\n\n  h5,\n  i {\n    color: $body-content-color;\n  }\n}\n\n// advice_sidebar\n.advice_sidebar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  overflow-y: auto;\n  width: calc(100% - 70px);\n  max-width: 240px;\n  background-color: #fff;\n  z-index: 999;\n  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.05);\n\n  &__wrapper {\n    padding: 10px;\n  }\n\n  &__header {\n    background-color: $color-neutral-light;\n    padding: 10px 35px 10px 15px;\n    border-radius: 4px;\n    font-size: 16px;\n    font-weight: 700;\n    color: $body-content-color;\n    position: relative;\n\n    &:not(:last-child) {\n      margin-bottom: 15px;\n    }\n  }\n\n  &__list {\n    padding-inline: 15px;\n\n    & > :not(:last-child) {\n      margin-bottom: 15px;\n    }\n\n    h5 {\n      font-weight: 700;\n      font-size: 14px;\n      margin-top: 0;\n\n      &:not(:last-child) {\n        margin-bottom: 5px;\n      }\n    }\n\n    ul {\n      margin: 0;\n      padding: 0;\n      list-style: none;\n    }\n\n    p,\n    li {\n      font-weight: 600;\n      font-size: 12px;\n\n      &:not(:last-child) {\n        margin-bottom: 10px;\n      }\n    }\n  }\n\n  &__close {\n    --line_thickness: 2px;\n    --line_length: 70%;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 10px;\n    margin-block: auto;\n    width: 18px;\n    aspect-ratio: 1;\n    background-color: transparent;\n    border: 0;\n    padding: 0;\n    cursor: pointer;\n\n    &:hover > div::before,\n    &:hover > div::after {\n      background-color: $develop-color;\n    }\n\n    div {\n      position: absolute;\n      inset: 0;\n      transform: rotate(45deg);\n\n      &::before,\n      &::after {\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        background-color: $body-content-color;\n        transition: all ease 0.3s;\n      }\n\n      &::before {\n        width: var(--line_thickness);\n        height: var(--line_length);\n      }\n\n      &::after {\n        width: var(--line_length);\n        height: var(--line_thickness);\n      }\n    }\n  }\n}\n\n::ng-deep.fa-chevron-up {\n  transition: all 0.3s ease;\n\n  &.active {\n    transform: rotate(180deg);\n  }\n}\n\n.txt_trnsfrm {\n  text-transform: capitalize;\n}\n\n.planchk {\n  // accent-color: #639935;\n}\n\n.counter {\n  display: block;\n  // height: 20px;\n  // width: 20px;\n  // border: 1px solid $color-grey-1;\n  // border-radius: 50%;\n  text-align: left;\n  font-weight: normal;\n  padding-top: 2px;\n  font-size: 10px;\n}\n\n.gap10 {\n  gap: 10px;\n}\n\n// .pd_percn {\n//     padding-left: 3%;\n//     padding-right: 7%;\n// }\n\n// advice_sidebar end\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
